webpackJsonp([87],{

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIsLoggedIn;
/* harmony export (immutable) */ __webpack_exports__["b"] = getIsLoggedInO365;
/* harmony export (immutable) */ __webpack_exports__["c"] = getUserInfo;
/* unused harmony export getUserEmail */
function getIsLoggedIn(state) {
    return !!state.auth.bsrsToken;
}

function getIsLoggedInO365(state) {
    return !!state.auth.token.access_token;
}

function getUserInfo(state) {
    return state.auth.user;
}

function getUserEmail(state) {
    return state.auth.user.email;
}

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_274", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_320", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_312", function() { return O365_REGISTER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_313", function() { return O365_REGISTER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_311", function() { return O365_REGISTER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_294", function() { return O365_LOAD_EVENTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_295", function() { return O365_LOAD_EVENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_293", function() { return O365_LOAD_EVENTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_297", function() { return O365_LOAD_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_298", function() { return O365_LOAD_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_296", function() { return O365_LOAD_EVENT_FAILURE; });
/* unused harmony export O365_LOAD_EDIT_EVENT_REQUEST */
/* unused harmony export O365_LOAD_EDIT_EVENT_SUCCESS */
/* unused harmony export O365_LOAD_EDIT_EVENT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_309", function() { return O365_LOAD_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_310", function() { return O365_LOAD_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_308", function() { return O365_LOAD_USER_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_279", function() { return O365_CREATE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_280", function() { return O365_CREATE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_278", function() { return O365_CREATE_EVENT_FAILURE; });
/* unused harmony export O365_UPDATE_EVENT_REQUEST */
/* unused harmony export O365_UPDATE_EVENT_SUCCESS */
/* unused harmony export O365_UPDATE_EVENT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_288", function() { return O365_DELETE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_289", function() { return O365_DELETE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_287", function() { return O365_DELETE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BSRS_LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BSRS_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BSRS_LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_318", function() { return PROFILE_LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_319", function() { return PROFILE_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_317", function() { return PROFILE_LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_276", function() { return O365_ACCEPT_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_277", function() { return O365_ACCEPT_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_275", function() { return O365_ACCEPT_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_315", function() { return O365_TENTATIVE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_316", function() { return O365_TENTATIVE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_314", function() { return O365_TENTATIVE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_285", function() { return O365_DECLINE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_286", function() { return O365_DECLINE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_284", function() { return O365_DECLINE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return CORE_LOAD_ORDERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return CORE_LOAD_ORDERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return CORE_LOAD_ORDERS_FAILURE; });
/* unused harmony export CORE_LOAD_ORDER_DETAIL_REQUEST */
/* unused harmony export CORE_LOAD_ORDER_DETAIL_SUCCESS */
/* unused harmony export CORE_LOAD_ORDER_DETAIL_FAILURE */
/* unused harmony export CORE_CHANGE_ORDER_AMOUNT */
/* unused harmony export CORE_UPSERT_ORDERS_REQUEST */
/* unused harmony export CORE_UPSERT_ORDERS_SUCCESS */
/* unused harmony export CORE_UPSERT_ORDERS_FAILURE */
/* unused harmony export CORE_LOAD_CHEKIN_REQUEST */
/* unused harmony export CORE_LOAD_CHEKIN_SUCCESS */
/* unused harmony export CORE_LOAD_CHEKIN_FAILURE */
/* unused harmony export CORE_CREATE_CHECKIN_REQUEST */
/* unused harmony export CORE_CREATE_CHECKIN_SUCCESS */
/* unused harmony export CORE_CREATE_CHECKIN_FAILURE */
/* unused harmony export O365_CHECKOUT_EVENT_REQUEST */
/* unused harmony export O365_CHECKOUT_EVENT_SUCCESS */
/* unused harmony export O365_CHECKOUT_EVENT_FAILURE */
/* unused harmony export O365_LOAD_PEOPLE_REQUEST */
/* unused harmony export O365_LOAD_PEOPLE_SUCCESS */
/* unused harmony export O365_LOAD_PEOPLE_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_300", function() { return O365_LOAD_LOCATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_301", function() { return O365_LOAD_LOCATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_299", function() { return O365_LOAD_LOCATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return CORE_LOAD_LOCATIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return CORE_LOAD_LOCATIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return CORE_LOAD_LOCATIONS_FAILURE; });
/* unused harmony export O365_SEARCH_SLOT_REQUEST */
/* unused harmony export O365_SEARCH_SLOT_SUCCESS */
/* unused harmony export O365_SEARCH_SLOT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return CORE_INTEGRATION_O365_GO_ADMIN_CONSENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return CORE_INTEGRATION_O365_GO_SAVE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return CORE_INTEGRATION_O365_ADD_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return CORE_INTEGRATION_O365_ADMIN_CONSENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return CORE_INTEGRATION_O365_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return CORE_INTEGRATION_O365_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return CORE_INTEGRATION_O365_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CORE_CREATE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CORE_CREATE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CORE_CREATE_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return CORE_LOAD_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return CORE_LOAD_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return CORE_LOAD_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return CORE_FIND_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return CORE_FIND_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CORE_FIND_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_257", function() { return CORE_UPDATE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_258", function() { return CORE_UPDATE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_256", function() { return CORE_UPDATE_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CORE_DELETE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CORE_DELETE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CORE_DELETE_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_291", function() { return O365_DELETE_ROOM_SUBSCRIBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_292", function() { return O365_DELETE_ROOM_SUBSCRIBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_290", function() { return O365_DELETE_ROOM_SUBSCRIBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_282", function() { return O365_CREATE_ROOM_SUBSCRIBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_283", function() { return O365_CREATE_ROOM_SUBSCRIBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_281", function() { return O365_CREATE_ROOM_SUBSCRIBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_303", function() { return O365_LOAD_ROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_304", function() { return O365_LOAD_ROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_302", function() { return O365_LOAD_ROOMS_FAILURE; });
/* unused harmony export O365_LOAD_ROOMS_INFO_REQUEST */
/* unused harmony export O365_LOAD_ROOMS_INFO_SUCCESS */
/* unused harmony export O365_LOAD_ROOMS_INFO_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_306", function() { return O365_LOAD_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_307", function() { return O365_LOAD_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_305", function() { return O365_LOAD_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BSRS_SERVICE_TOKEN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BSRS_SERVICE_TOKEN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BSRS_SERVICE_TOKEN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return CORE_LOAD_ROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return CORE_LOAD_ROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return CORE_LOAD_ROOMS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return CORE_LOAD_ROOMS_SUBSCRIBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return CORE_LOAD_REPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return CORE_LOAD_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return CORE_LOAD_REPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return CORE_LOAD_LOCATIONS_REPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return CORE_LOAD_LOCATIONS_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return CORE_LOAD_LOCATIONS_REPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CORE_CREATE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CORE_CREATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CORE_CREATE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_206", function() { return CORE_LOAD_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_207", function() { return CORE_LOAD_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_205", function() { return CORE_LOAD_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_212", function() { return CORE_LOAD_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_213", function() { return CORE_LOAD_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_208", function() { return CORE_LOAD_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_266", function() { return CORE_UPDATE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_267", function() { return CORE_UPDATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_265", function() { return CORE_UPDATE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CORE_DELETE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return CORE_DELETE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CORE_DELETE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_272", function() { return CORE_USER_CHANGEPASS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_273", function() { return CORE_USER_CHANGEPASS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_271", function() { return CORE_USER_CHANGEPASS_FAILURE; });
/* unused harmony export CORE_EDIT_USER_REQUEST */
/* unused harmony export CORE_EDIT_USER_SUCCESS */
/* unused harmony export CORE_EDIT_USER_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_210", function() { return CORE_LOAD_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_211", function() { return CORE_LOAD_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_209", function() { return CORE_LOAD_USER_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_CHANGE_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_CHANGE_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_CHANGE_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return CORE_GET_INTEGRATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return CORE_GET_INTEGRATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return CORE_GET_INTEGRATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return CORE_LOAD_SETTING_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return CORE_LOAD_SETTING_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return CORE_LOAD_SETTING_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_CHANGE_SETTING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_CHANGE_SETTING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_CHANGE_SETTING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_197", function() { return CORE_LOAD_USERREPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_198", function() { return CORE_LOAD_USERREPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_196", function() { return CORE_LOAD_USERREPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return CORE_LOAD_ROOMREPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return CORE_LOAD_ROOMREPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return CORE_LOAD_ROOMREPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_200", function() { return CORE_LOAD_USERSUMMARY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_201", function() { return CORE_LOAD_USERSUMMARY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_199", function() { return CORE_LOAD_USERSUMMARY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return CORE_LOAD_ROOMSUMMARY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return CORE_LOAD_ROOMSUMMARY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return CORE_LOAD_ROOMSUMMARY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return CORE_LOAD_REPORTSUMMARY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return CORE_LOAD_REPORTSUMMARY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return CORE_LOAD_REPORTSUMMARY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return CORE_LOAD_ALLAMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return CORE_LOAD_ALLAMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return CORE_LOAD_ALLAMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CORE_DELETE_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CORE_DELETE_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CORE_DELETE_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return CORE_LOAD_AMENITYINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return CORE_LOAD_AMENITYINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return CORE_LOAD_AMENITYINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CORE_CREATE_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CORE_CREATE_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CORE_CREATE_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_218", function() { return CORE_UPDATE_AMENITYINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_219", function() { return CORE_UPDATE_AMENITYINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_217", function() { return CORE_UPDATE_AMENITYINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return CORE_LOAD_ALL_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return CORE_LOAD_ALL_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return CORE_LOAD_ALL_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return CORE_LOAD_PROFILE_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return CORE_LOAD_PROFILE_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return CORE_LOAD_PROFILE_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CORE_CREATE_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CORE_CREATE_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CORE_CREATE_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_254", function() { return CORE_UPDATE_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_255", function() { return CORE_UPDATE_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_253", function() { return CORE_UPDATE_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CORE_DELETE_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CORE_DELETE_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CORE_DELETE_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_191", function() { return CORE_LOAD_USERGROUPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_192", function() { return CORE_LOAD_USERGROUPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_190", function() { return CORE_LOAD_USERGROUPS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return CORE_LOAD_LIST_USERGROUPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return CORE_LOAD_LIST_USERGROUPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return CORE_LOAD_LIST_USERGROUPS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_194", function() { return CORE_LOAD_USERGROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_195", function() { return CORE_LOAD_USERGROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_193", function() { return CORE_LOAD_USERGROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CORE_CREATE_USERGROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CORE_CREATE_USERGROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CORE_CREATE_USERGROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_263", function() { return CORE_UPDATE_USERGROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_264", function() { return CORE_UPDATE_USERGROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_262", function() { return CORE_UPDATE_USERGROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CORE_DELETE_USERGROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CORE_DELETE_USERGROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CORE_DELETE_USERGROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return CORE_LOAD_ACTIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return CORE_LOAD_ACTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return CORE_LOAD_ACTIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return CORE_LOAD_ALLFBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return CORE_LOAD_ALLFBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return CORE_LOAD_ALLFBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CORE_DELETE_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CORE_DELETE_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CORE_DELETE_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return CORE_LOAD_FBSINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return CORE_LOAD_FBSINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return CORE_LOAD_FBSINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_CREATE_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_CREATE_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_CREATE_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_239", function() { return CORE_UPDATE_FBSINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_240", function() { return CORE_UPDATE_FBSINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_238", function() { return CORE_UPDATE_FBSINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return CORE_GET_INTEGRATION_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return CORE_GET_INTEGRATION_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return CORE_GET_INTEGRATION_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return CORE_LOAD_STATUSUSER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return CORE_LOAD_STATUSUSER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return CORE_LOAD_STATUSUSER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_203", function() { return CORE_LOAD_USERSUM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_204", function() { return CORE_LOAD_USERSUM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_202", function() { return CORE_LOAD_USERSUM_FAILURE; });
/* unused harmony export CORE_LOAD_ROOMSUM_REQUEST */
/* unused harmony export CORE_LOAD_ROOMSUM_SUCCESS */
/* unused harmony export CORE_LOAD_ROOMSUM_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return CORE_LOAD_ROOMTEMP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return CORE_LOAD_ROOMTEMP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return CORE_LOAD_ROOMTEMP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return CORE_LOAD_TOPROOMRESERVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return CORE_LOAD_TOPROOMRESERVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return CORE_LOAD_TOPROOMRESERVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_188", function() { return CORE_LOAD_TOPUSERRESERVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_189", function() { return CORE_LOAD_TOPUSERRESERVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_187", function() { return CORE_LOAD_TOPUSERRESERVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return CORE_LOAD_ROOMDETAIL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return CORE_LOAD_ROOMDETAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return CORE_LOAD_ROOMDETAIL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return CORE_LOAD_TERM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return CORE_LOAD_TERM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return CORE_LOAD_TERM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_260", function() { return CORE_UPDATE_TERM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_261", function() { return CORE_UPDATE_TERM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_259", function() { return CORE_UPDATE_TERM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return CORE_LOAD_FAQ_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return CORE_LOAD_FAQ_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return CORE_LOAD_FAQ_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_236", function() { return CORE_UPDATE_FAQ_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_237", function() { return CORE_UPDATE_FAQ_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_235", function() { return CORE_UPDATE_FAQ_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return CORE_LOAD_CONTACT_US_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return CORE_LOAD_CONTACT_US_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return CORE_LOAD_CONTACT_US_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_227", function() { return CORE_UPDATE_CONTACT_US_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_228", function() { return CORE_UPDATE_CONTACT_US_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_226", function() { return CORE_UPDATE_CONTACT_US_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return CORE_LOAD_REPORTROOMSTATUS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return CORE_LOAD_REPORTROOMSTATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return CORE_LOAD_REPORTROOMSTATUS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return CORE_LOAD_ALL_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return CORE_LOAD_ALL_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return CORE_LOAD_ALL_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return CORE_LOAD_ALLBUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return CORE_LOAD_ALLBUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return CORE_LOAD_ALLBUILDING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CORE_DELETE_BUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CORE_DELETE_BUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CORE_DELETE_BUILDING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return CORE_LOAD_BUILDINGINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return CORE_LOAD_BUILDINGINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return CORE_LOAD_BUILDINGINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_224", function() { return CORE_UPDATE_BUILDINGINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_225", function() { return CORE_UPDATE_BUILDINGINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_223", function() { return CORE_UPDATE_BUILDINGINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CORE_CREATE_BUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CORE_CREATE_BUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CORE_CREATE_BUILDING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return CORE_LOAD_ALLFLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return CORE_LOAD_ALLFLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return CORE_LOAD_ALLFLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CORE_DELETE_FLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CORE_DELETE_FLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CORE_DELETE_FLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return CORE_LOAD_FLOORINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return CORE_LOAD_FLOORINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return CORE_LOAD_FLOORINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_245", function() { return CORE_UPDATE_FLOORINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_246", function() { return CORE_UPDATE_FLOORINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_244", function() { return CORE_UPDATE_FLOORINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CORE_CREATE_FLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CORE_CREATE_FLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CORE_CREATE_FLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return CORE_LOAD_ALLZONE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return CORE_LOAD_ALLZONE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return CORE_LOAD_ALLZONE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return CORE_DELETE_ZONE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CORE_DELETE_ZONE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return CORE_DELETE_ZONE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_215", function() { return CORE_LOAD_ZONEINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_216", function() { return CORE_LOAD_ZONEINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_214", function() { return CORE_LOAD_ZONEINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_269", function() { return CORE_UPDATE_ZONEINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_270", function() { return CORE_UPDATE_ZONEINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_268", function() { return CORE_UPDATE_ZONEINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CORE_CREATE_ZONE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CORE_CREATE_ZONE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CORE_CREATE_ZONE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return CORE_LOAD_ALLBACKGROUND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return CORE_LOAD_ALLBACKGROUND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return CORE_LOAD_ALLBACKGROUND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CORE_DELETE_BACKGROUND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CORE_DELETE_BACKGROUND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CORE_DELETE_BACKGROUND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return CORE_LOAD_BACKGROUNDINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return CORE_LOAD_BACKGROUNDINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return CORE_LOAD_BACKGROUNDINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_221", function() { return CORE_UPDATE_BACKGROUNDINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_222", function() { return CORE_UPDATE_BACKGROUNDINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_220", function() { return CORE_UPDATE_BACKGROUNDINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_CREATE_BACKGROUND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_CREATE_BACKGROUND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_CREATE_BACKGROUND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_230", function() { return CORE_UPDATE_DEFAULTBACKGROUND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_231", function() { return CORE_UPDATE_DEFAULTBACKGROUND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_229", function() { return CORE_UPDATE_DEFAULTBACKGROUND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CORE_GET_CATEGORY_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return CORE_GET_CATEGORY_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CORE_GET_CATEGORY_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_242", function() { return CORE_UPDATE_FB_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_243", function() { return CORE_UPDATE_FB_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_241", function() { return CORE_UPDATE_FB_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CORE_CREATE_FB_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CORE_CREATE_FB_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CORE_CREATE_FB_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CORE_DELETE_FB_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CORE_DELETE_FB_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CORE_DELETE_FB_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return CORE_LOAD_ALL_USERSAD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return CORE_LOAD_ALL_USERSAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return CORE_LOAD_ALL_USERSAD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_CHECK_AD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_CHECK_AD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_CHECK_AD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return CORE_LOAD_TIMEZOZE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return CORE_LOAD_TIMEZOZE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return CORE_LOAD_TIMEZOZE_FAILURE; });
/* unused harmony export CORE_DELETE_IOT_REQUEST */
/* unused harmony export CORE_DELETE_IOT_SUCCESS */
/* unused harmony export CORE_DELETE_IOT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_251", function() { return CORE_UPDATE_IOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_252", function() { return CORE_UPDATE_IOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_250", function() { return CORE_UPDATE_IOT_FAILURE; });
/* unused harmony export CORE_CREATE_IOT_REQUEST */
/* unused harmony export CORE_CREATE_IOT_SUCCESS */
/* unused harmony export CORE_CREATE_IOT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return CORE_LOAD_IOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return CORE_LOAD_IOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return CORE_LOAD_IOT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return CORE_GET_IOT_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return CORE_GET_IOT_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return CORE_GET_IOT_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CORE_EDIT_GOOGLE_INTEGRATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CORE_EDIT_GOOGLE_INTEGRATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CORE_EDIT_GOOGLE_INTEGRATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_248", function() { return CORE_UPDATE_HOTSEAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_249", function() { return CORE_UPDATE_HOTSEAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_247", function() { return CORE_UPDATE_HOTSEAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return CORE_LOAD_ALLSEAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return CORE_LOAD_ALLSEAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return CORE_LOAD_ALLSEAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return CORE_LOAD_SEATINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return CORE_LOAD_SEATINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return CORE_LOAD_SEATINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return CORE_LOAD_ALLDISABLESEAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return CORE_LOAD_ALLDISABLESEAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return CORE_LOAD_ALLDISABLESEAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CORE_CREATE_DISABLEDSEAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CORE_CREATE_DISABLEDSEAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CORE_CREATE_DISABLEDSEAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return CORE_LOAD_DISABLESEATINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return CORE_LOAD_DISABLESEATINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return CORE_LOAD_DISABLESEATINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_233", function() { return CORE_UPDATE_DISABLESEATINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_234", function() { return CORE_UPDATE_DISABLESEATINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_232", function() { return CORE_UPDATE_DISABLESEATINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CORE_DELETE_DISABLESEATINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CORE_DELETE_DISABLESEATINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CORE_DELETE_DISABLESEATINFO_FAILURE; });
var LOGOUT = 'LOGOUT';
var SET_ERROR = 'SET_ERROR';

var O365_REGISTER_REQUEST = 'O365_REGISTER_REQUEST';
var O365_REGISTER_SUCCESS = 'O365_REGISTER_SUCCESS';
var O365_REGISTER_FAILURE = 'O365_REGISTER_FAILURE';

var O365_LOAD_EVENTS_REQUEST = 'O365_LOAD_EVENTS_REQUEST';
var O365_LOAD_EVENTS_SUCCESS = 'O365_LOAD_EVENTS_SUCCESS';
var O365_LOAD_EVENTS_FAILURE = 'O365_LOAD_EVENTS_FAILURE';

var O365_LOAD_EVENT_REQUEST = 'O365_LOAD_EVENT_REQUEST';
var O365_LOAD_EVENT_SUCCESS = 'O365_LOAD_EVENT_SUCCESS';
var O365_LOAD_EVENT_FAILURE = 'O365_LOAD_EVENT_FAILURE';

var O365_LOAD_EDIT_EVENT_REQUEST = 'O365_LOAD_EDIT_EVENT_REQUEST';
var O365_LOAD_EDIT_EVENT_SUCCESS = 'O365_LOAD_EDIT_EVENT_SUCCESS';
var O365_LOAD_EDIT_EVENT_FAILURE = 'O365_LOAD_EDIT_EVENT_FAILURE';

var O365_LOAD_USER_INFO_REQUEST = 'O365_LOAD_USER_INFO_REQUEST';
var O365_LOAD_USER_INFO_SUCCESS = 'O365_LOAD_USER_INFO_SUCCESS';
var O365_LOAD_USER_INFO_FAILURE = 'O365_LOAD_USER_INFO_FAILURE';

var O365_CREATE_EVENT_REQUEST = 'O365_CREATE_EVENT_REQUEST';
var O365_CREATE_EVENT_SUCCESS = 'O365_CREATE_EVENT_SUCCESS';
var O365_CREATE_EVENT_FAILURE = 'O365_CREATE_EVENT_FAILURE';

var O365_UPDATE_EVENT_REQUEST = 'O365_UPDATE_EVENT_REQUEST';
var O365_UPDATE_EVENT_SUCCESS = 'O365_UPDATE_EVENT_SUCCESS';
var O365_UPDATE_EVENT_FAILURE = 'O365_UPDATE_EVENT_FAILURE';

var O365_DELETE_EVENT_REQUEST = 'O365_DELETE_EVENT_REQUEST';
var O365_DELETE_EVENT_SUCCESS = 'O365_DELETE_EVENT_SUCCESS';
var O365_DELETE_EVENT_FAILURE = 'O365_DELETE_EVENT_FAILURE';

var BSRS_LOGIN_REQUEST = 'BSRS_LOGIN_REQUEST';
var BSRS_LOGIN_SUCCESS = 'BSRS_LOGIN_SUCCESS';
var BSRS_LOGIN_FAILURE = 'BSRS_LOGIN_FAILURE';

var PROFILE_LOGIN_REQUEST = 'PROFILE_LOGIN_REQUEST';
var PROFILE_LOGIN_SUCCESS = 'PROFILE_LOGIN_SUCCESS';
var PROFILE_LOGIN_FAILURE = 'PROFILE_LOGIN_FAILURE';

var O365_ACCEPT_EVENT_REQUEST = 'O365_ACCEPT_EVENT_REQUEST';
var O365_ACCEPT_EVENT_SUCCESS = 'O365_ACCEPT_EVENT_SUCCESS';
var O365_ACCEPT_EVENT_FAILURE = 'O365_ACCEPT_EVENT_FAILURE';

var O365_TENTATIVE_EVENT_REQUEST = 'O365_TENTATIVE_EVENT_REQUEST';
var O365_TENTATIVE_EVENT_SUCCESS = 'O365_TENTATIVE_EVENT_SUCCESS';
var O365_TENTATIVE_EVENT_FAILURE = 'O365_TENTATIVE_EVENT_FAILURE';

var O365_DECLINE_EVENT_REQUEST = 'O365_DECLINE_EVENT_REQUEST';
var O365_DECLINE_EVENT_SUCCESS = 'O365_DECLINE_EVENT_SUCCESS';
var O365_DECLINE_EVENT_FAILURE = 'O365_DECLINE_EVENT_FAILURE';

var CORE_LOAD_ORDERS_REQUEST = 'CORE_LOAD_ORDERS_REQUEST';
var CORE_LOAD_ORDERS_SUCCESS = 'CORE_LOAD_ORDERS_SUCCESS';
var CORE_LOAD_ORDERS_FAILURE = 'CORE_LOAD_ORDERS_FAILURE';

var CORE_LOAD_ORDER_DETAIL_REQUEST = 'CORE_LOAD_ORDER_DETAIL_REQUEST';
var CORE_LOAD_ORDER_DETAIL_SUCCESS = 'CORE_LOAD_ORDER_DETAIL_SUCCESS';
var CORE_LOAD_ORDER_DETAIL_FAILURE = 'CORE_LOAD_ORDER_DETAIL_FAILURE';

var CORE_CHANGE_ORDER_AMOUNT = 'CORE_CHANGE_ORDER_AMOUNT';

var CORE_UPSERT_ORDERS_REQUEST = 'CORE_UPSERT_ORDERS_REQUEST';
var CORE_UPSERT_ORDERS_SUCCESS = 'CORE_UPSERT_ORDERS_SUCCESS';
var CORE_UPSERT_ORDERS_FAILURE = 'CORE_UPSERT_ORDERS_FAILURE';

var CORE_LOAD_CHEKIN_REQUEST = 'CORE_LOAD_CHEKIN_REQUEST';
var CORE_LOAD_CHEKIN_SUCCESS = 'CORE_LOAD_CHEKIN_SUCCESS';
var CORE_LOAD_CHEKIN_FAILURE = 'CORE_LOAD_CHEKIN_FAILURE';

var CORE_CREATE_CHECKIN_REQUEST = 'CORE_CREATE_CHECKIN_REQUEST';
var CORE_CREATE_CHECKIN_SUCCESS = 'CORE_CREATE_CHECKIN_SUCCESS';
var CORE_CREATE_CHECKIN_FAILURE = 'CORE_CREATE_CHECKIN_FAILURE';

var O365_CHECKOUT_EVENT_REQUEST = 'O365_CHECKOUT_EVENT_REQUEST';
var O365_CHECKOUT_EVENT_SUCCESS = 'O365_CHECKOUT_EVENT_SUCCESS';
var O365_CHECKOUT_EVENT_FAILURE = 'O365_CHECKOUT_EVENT_FAILURE';

var O365_LOAD_PEOPLE_REQUEST = 'O365_LOAD_PEOPLE_REQUEST';
var O365_LOAD_PEOPLE_SUCCESS = 'O365_LOAD_PEOPLE_SUCCESS';
var O365_LOAD_PEOPLE_FAILURE = 'O365_LOAD_PEOPLE_FAILURE';

var O365_LOAD_LOCATION_REQUEST = 'O365_LOAD_LOCATION_REQUEST';
var O365_LOAD_LOCATION_SUCCESS = 'O365_LOAD_LOCATION_SUCCESS';
var O365_LOAD_LOCATION_FAILURE = 'O365_LOAD_LOCATION_FAILURE';

var CORE_LOAD_LOCATIONS_REQUEST = 'CORE_LOAD_LOCATIONS_REQUEST';
var CORE_LOAD_LOCATIONS_SUCCESS = 'CORE_LOAD_LOCATIONS_SUCCESS';
var CORE_LOAD_LOCATIONS_FAILURE = 'CORE_LOAD_LOCATIONS_FAILURE';

var O365_SEARCH_SLOT_REQUEST = 'O365_SEARCH_SLOT_REQUEST';
var O365_SEARCH_SLOT_SUCCESS = 'O365_SEARCH_SLOT_SUCCESS';
var O365_SEARCH_SLOT_FAILURE = 'O365_SEARCH_SLOT_FAILURE';

var CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID = 'CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID';
var CORE_INTEGRATION_O365_GO_ADMIN_CONSENT = 'CORE_INTEGRATION_O365_GO_ADMIN_CONSENT';
var CORE_INTEGRATION_O365_GO_SAVE_DATA = 'CORE_INTEGRATION_O365_GO_SAVE_DATA';

var CORE_INTEGRATION_O365_ADD_CLIENT_ID = 'CORE_INTEGRATION_O365_ADD_CLIENT_ID';
var CORE_INTEGRATION_O365_ADMIN_CONSENT = 'CORE_INTEGRATION_O365_ADMIN_CONSENT';
var CORE_INTEGRATION_O365_REQUEST = 'CORE_INTEGRATION_O365_REQUEST';
var CORE_INTEGRATION_O365_SUCCESS = 'CORE_INTEGRATION_O365_SUCCESS';
var CORE_INTEGRATION_O365_FAILURE = 'CORE_INTEGRATION_O365_FAILURE';

var CORE_CREATE_ROOM_REQUEST = 'CORE_CREATE_ROOM_REQUEST';
var CORE_CREATE_ROOM_SUCCESS = 'CORE_CREATE_ROOM_SUCCESS';
var CORE_CREATE_ROOM_FAILURE = 'CORE_CREATE_ROOM_FAILURE';

var CORE_LOAD_ROOM_REQUEST = 'CORE_LOAD_ROOM_REQUEST';
var CORE_LOAD_ROOM_SUCCESS = 'CORE_LOAD_ROOM_SUCCESS';
var CORE_LOAD_ROOM_FAILURE = 'CORE_LOAD_ROOM_FAILURE';

var CORE_FIND_ROOM_REQUEST = 'CORE_FIND_ROOM_REQUEST';
var CORE_FIND_ROOM_SUCCESS = 'CORE_FIND_ROOM_SUCCESS';
var CORE_FIND_ROOM_FAILURE = 'CORE_FIND_ROOM_FAILURE';

var CORE_UPDATE_ROOM_REQUEST = 'CORE_UPDATE_ROOM_REQUEST';
var CORE_UPDATE_ROOM_SUCCESS = 'CORE_UPDATE_ROOM_SUCCESS';
var CORE_UPDATE_ROOM_FAILURE = 'CORE_UPDATE_ROOM_FAILURE';

var CORE_DELETE_ROOM_REQUEST = 'CORE_DELETE_ROOM_REQUEST';
var CORE_DELETE_ROOM_SUCCESS = 'CORE_DELETE_ROOM_SUCCESS';
var CORE_DELETE_ROOM_FAILURE = 'CORE_DELETE_ROOM_FAILURE';

var O365_DELETE_ROOM_SUBSCRIBE_REQUEST = 'O365_DELETE_ROOM_SUBSCRIBE_REQUEST';
var O365_DELETE_ROOM_SUBSCRIBE_SUCCESS = 'O365_DELETE_ROOM_SUBSCRIBE_SUCCESS';
var O365_DELETE_ROOM_SUBSCRIBE_FAILURE = 'O365_DELETE_ROOM_SUBSCRIBE_FAILURE';

var O365_CREATE_ROOM_SUBSCRIBE_REQUEST = 'O365_CREATE_ROOM_SUBSCRIBE_REQUEST';
var O365_CREATE_ROOM_SUBSCRIBE_SUCCESS = 'O365_CREATE_ROOM_SUBSCRIBE_SUCCESS';
var O365_CREATE_ROOM_SUBSCRIBE_FAILURE = 'O365_CREATE_ROOM_SUBSCRIBE_FAILURE';

var O365_LOAD_ROOMS_REQUEST = 'O365_LOAD_ROOMS_REQUEST';
var O365_LOAD_ROOMS_SUCCESS = 'O365_LOAD_ROOMS_SUCCESS';
var O365_LOAD_ROOMS_FAILURE = 'O365_LOAD_ROOMS_FAILURE';

var O365_LOAD_ROOMS_INFO_REQUEST = 'O365_LOAD_ROOMS_INFO_REQUEST';
var O365_LOAD_ROOMS_INFO_SUCCESS = 'O365_LOAD_ROOMS_INFO_SUCCESS';
var O365_LOAD_ROOMS_INFO_FAILURE = 'O365_LOAD_ROOMS_INFO_FAILURE';

var O365_LOAD_USERS_REQUEST = 'O365_LOAD_USERS_REQUEST';
var O365_LOAD_USERS_SUCCESS = 'O365_LOAD_USERS_SUCCESS';
var O365_LOAD_USERS_FAILURE = 'O365_LOAD_USERS_FAILURE';

var BSRS_SERVICE_TOKEN_REQUEST = 'BSRS_SERVICE_TOKEN_REQUEST';
var BSRS_SERVICE_TOKEN_SUCCESS = 'BSRS_SERVICE_TOKEN_SUCCESS';
var BSRS_SERVICE_TOKEN_FAILURE = 'BSRS_SERVICE_TOKEN_FAILURE';

var CORE_LOAD_ROOMS_REQUEST = 'CORE_LOAD_ROOMS_REQUEST';
var CORE_LOAD_ROOMS_SUCCESS = 'CORE_LOAD_ROOMS_SUCCESS';
var CORE_LOAD_ROOMS_FAILURE = 'CORE_LOAD_ROOMS_FAILURE';

var CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST = 'CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST';
var CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS = 'CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS';
var CORE_LOAD_ROOMS_SUBSCRIBE_FAILURE = 'CORE_LOAD_ROOMS_SUBSCRIBE_FAILURE';

var CORE_LOAD_REPORT_REQUEST = 'CORE_LOAD_REPORT_REQUEST';
var CORE_LOAD_REPORT_SUCCESS = 'CORE_LOAD_REPORT_SUCCESS';
var CORE_LOAD_REPORT_FAILURE = 'CORE_LOAD_REPORT_FAILURE';

var CORE_LOAD_LOCATIONS_REPORT_REQUEST = 'CORE_LOAD_LOCATIONS_REPORT_REQUEST';
var CORE_LOAD_LOCATIONS_REPORT_SUCCESS = 'CORE_LOAD_LOCATIONS_REPORT_SUCCESS';
var CORE_LOAD_LOCATIONS_REPORT_FAILURE = 'CORE_LOAD_LOCATIONS_REPORT_FAILURE';

var CORE_CREATE_USER_REQUEST = 'CORE_CREATE_USER_REQUEST';
var CORE_CREATE_USER_SUCCESS = 'CORE_CREATE_USER_SUCCESS';
var CORE_CREATE_USER_FAILURE = 'CORE_CREATE_USER_FAILURE';

var CORE_LOAD_USERS_REQUEST = 'CORE_LOAD_USERS_REQUEST';
var CORE_LOAD_USERS_SUCCESS = 'CORE_LOAD_USERS_SUCCESS';
var CORE_LOAD_USERS_FAILURE = 'CORE_LOAD_USERS_FAILURE';

var CORE_LOAD_USER_REQUEST = 'CORE_LOAD_USER_REQUEST';
var CORE_LOAD_USER_SUCCESS = 'CORE_LOAD_USER_SUCCESS';
var CORE_LOAD_USER_FAILURE = 'CORE_LOAD_USER_FAILURE';

var CORE_UPDATE_USER_REQUEST = 'CORE_UPDATE_USER_REQUEST';
var CORE_UPDATE_USER_SUCCESS = 'CORE_UPDATE_USER_SUCCESS';
var CORE_UPDATE_USER_FAILURE = 'CORE_UPDATE_USER_FAILURE';

var CORE_DELETE_USER_REQUEST = 'CORE_DELETE_USER_REQUEST';
var CORE_DELETE_USER_SUCCESS = 'CORE_DELETE_USER_SUCCESS';
var CORE_DELETE_USER_FAILURE = 'CORE_DELETE_USER_FAILURE';

var CORE_USER_CHANGEPASS_REQUEST = 'CORE_USER_CHANGEPASS_REQUEST';
var CORE_USER_CHANGEPASS_SUCCESS = 'CORE_USER_CHANGEPASS_SUCCESS';
var CORE_USER_CHANGEPASS_FAILURE = 'CORE_USER_CHANGEPASS_FAILURE';

var CORE_EDIT_USER_REQUEST = 'CORE_EDIT_USER_REQUEST';
var CORE_EDIT_USER_SUCCESS = 'CORE_EDIT_USER_SUCCESS';
var CORE_EDIT_USER_FAILURE = 'CORE_EDIT_USER_FAILURE';

var CORE_LOAD_USER_INFO_REQUEST = 'CORE_LOAD_USER_INFO_REQUEST';
var CORE_LOAD_USER_INFO_SUCCESS = 'CORE_LOAD_USER_INFO_SUCCESS';
var CORE_LOAD_USER_INFO_FAILURE = 'CORE_LOAD_USER_INFO_FAILURE';

var CORE_CHANGE_PASSWORD_REQUEST = 'CORE_CHANGE_PASSWORD_REQUEST';
var CORE_CHANGE_PASSWORD_SUCCESS = 'CORE_CHANGE_PASSWORD_SUCCESS';
var CORE_CHANGE_PASSWORD_FAILURE = 'CORE_CHANGE_PASSWORD_FAILURE';

var CORE_GET_INTEGRATION_REQUEST = 'CORE_GET_INTEGRATION_REQUEST';
var CORE_GET_INTEGRATION_SUCCESS = 'CORE_GET_INTEGRATION_SUCCESS';
var CORE_GET_INTEGRATION_FAILURE = 'CORE_GET_INTEGRATION_FAILURE';

var CORE_LOAD_SETTING_INFO_REQUEST = 'CORE_LOAD_SETTING_INFO_REQUEST';
var CORE_LOAD_SETTING_INFO_SUCCESS = 'CORE_LOAD_SETTING_INFO_SUCCESS';
var CORE_LOAD_SETTING_INFO_FAILURE = 'CORE_LOAD_SETTING_INFO_FAILURE';

var CORE_CHANGE_SETTING_REQUEST = 'CORE_CHANGE_SETTING_REQUEST';
var CORE_CHANGE_SETTING_SUCCESS = 'CORE_CHANGE_SETTING_SUCCESS';
var CORE_CHANGE_SETTING_FAILURE = 'CORE_CHANGE_SETTING_FAILURE';

var CORE_LOAD_USERREPORT_REQUEST = 'CORE_LOAD_USERREPORT_REQUEST';
var CORE_LOAD_USERREPORT_SUCCESS = 'CORE_LOAD_USERREPORT_SUCCESS';
var CORE_LOAD_USERREPORT_FAILURE = 'CORE_LOAD_USERREPORT_FAILURE';

var CORE_LOAD_ROOMREPORT_REQUEST = 'CORE_LOAD_ROOMREPORT_REQUEST';
var CORE_LOAD_ROOMREPORT_SUCCESS = 'CORE_LOAD_ROOMREPORT_SUCCESS';
var CORE_LOAD_ROOMREPORT_FAILURE = 'CORE_LOAD_ROOMREPORT_FAILURE';

var CORE_LOAD_USERSUMMARY_REQUEST = 'CORE_LOAD_USERSUMMARY_REQUEST';
var CORE_LOAD_USERSUMMARY_SUCCESS = 'CORE_LOAD_USERSUMMARY_SUCCESS';
var CORE_LOAD_USERSUMMARY_FAILURE = 'CORE_LOAD_USERSUMMARY_FAILURE';

var CORE_LOAD_ROOMSUMMARY_REQUEST = 'CORE_LOAD_ROOMSUMMARY_REQUEST';
var CORE_LOAD_ROOMSUMMARY_SUCCESS = 'CORE_LOAD_ROOMSUMMARY_SUCCESS';
var CORE_LOAD_ROOMSUMMARY_FAILURE = 'CORE_LOAD_ROOMSUMMARY_FAILURE';

var CORE_LOAD_REPORTSUMMARY_REQUEST = 'CORE_LOAD_REPORTSUMMARY_REQUEST';
var CORE_LOAD_REPORTSUMMARY_SUCCESS = 'CORE_LOAD_REPORTSUMMARY_SUCCESS';
var CORE_LOAD_REPORTSUMMARY_FAILURE = 'CORE_LOAD_REPORTSUMMARY_FAILURE';

var CORE_LOAD_ALLAMENITY_REQUEST = 'CORE_LOAD_ALLAMENITY_REQUEST';
var CORE_LOAD_ALLAMENITY_SUCCESS = 'CORE_LOAD_ALLAMENITY_SUCCESS';
var CORE_LOAD_ALLAMENITY_FAILURE = 'CORE_LOAD_ALLAMENITY_FAILURE';

var CORE_DELETE_AMENITY_REQUEST = 'CORE_DELETE_AMENITY_REQUEST';
var CORE_DELETE_AMENITY_SUCCESS = 'CORE_DELETE_AMENITY_SUCCESS';
var CORE_DELETE_AMENITY_FAILURE = 'CORE_DELETE_AMENITY_FAILURE';

var CORE_LOAD_AMENITYINFO_REQUEST = 'CORE_LOAD_AMENITYINFO_REQUEST';
var CORE_LOAD_AMENITYINFO_SUCCESS = 'CORE_LOAD_AMENITYINFO_SUCCESS';
var CORE_LOAD_AMENITYINFO_FAILURE = 'CORE_LOAD_AMENITYINFO_FAILURE';

var CORE_CREATE_AMENITY_REQUEST = 'CORE_CREATE_AMENITY_REQUEST';
var CORE_CREATE_AMENITY_SUCCESS = 'CORE_CREATE_AMENITY_SUCCESS';
var CORE_CREATE_AMENITY_FAILURE = 'CORE_CREATE_AMENITY_FAILURE';

var CORE_UPDATE_AMENITYINFO_REQUEST = 'CORE_UPDATE_AMENITYINFO_REQUEST';
var CORE_UPDATE_AMENITYINFO_SUCCESS = 'CORE_UPDATE_AMENITYINFO_SUCCESS';
var CORE_UPDATE_AMENITYINFO_FAILURE = 'CORE_UPDATE_AMENITYINFO_FAILURE';

var CORE_LOAD_ALL_PROFILE_REQUEST = 'CORE_LOAD_ALL_PROFILE_REQUEST';
var CORE_LOAD_ALL_PROFILE_SUCCESS = 'CORE_LOAD_ALL_PROFILE_SUCCESS';
var CORE_LOAD_ALL_PROFILE_FAILURE = 'CORE_LOAD_ALL_PROFILE_FAILURE';

var CORE_LOAD_PROFILE_INFO_REQUEST = 'CORE_LOAD_PROFILE_INFO_REQUEST';
var CORE_LOAD_PROFILE_INFO_SUCCESS = 'CORE_LOAD_PROFILE_INFO_SUCCESS';
var CORE_LOAD_PROFILE_INFO_FAILURE = 'CORE_LOAD_PROFILE_INFO_FAILURE';

var CORE_CREATE_PROFILE_REQUEST = 'CORE_CREATE_PROFILE_REQUEST';
var CORE_CREATE_PROFILE_SUCCESS = 'CORE_CREATE_PROFILE_SUCCESS';
var CORE_CREATE_PROFILE_FAILURE = 'CORE_CREATE_PROFILE_FAILURE';

var CORE_UPDATE_PROFILE_REQUEST = 'CORE_UPDATE_PROFILE_REQUEST';
var CORE_UPDATE_PROFILE_SUCCESS = 'CORE_UPDATE_PROFILE_SUCCESS';
var CORE_UPDATE_PROFILE_FAILURE = 'CORE_UPDATE_PROFILE_FAILURE';

var CORE_DELETE_PROFILE_REQUEST = 'CORE_DELETE_PROFILE_REQUEST';
var CORE_DELETE_PROFILE_SUCCESS = 'CORE_DELETE_PROFILE_SUCCESS';
var CORE_DELETE_PROFILE_FAILURE = 'CORE_DELETE_PROFILE_FAILURE';

var CORE_LOAD_USERGROUPS_REQUEST = 'CORE_LOAD_USERGROUPS_REQUEST';
var CORE_LOAD_USERGROUPS_SUCCESS = 'CORE_LOAD_USERGROUPS_SUCCESS';
var CORE_LOAD_USERGROUPS_FAILURE = 'CORE_LOAD_USERGROUPS_FAILURE';

var CORE_LOAD_LIST_USERGROUPS_REQUEST = 'CORE_LOAD_LIST_USERGROUPS_REQUEST';
var CORE_LOAD_LIST_USERGROUPS_SUCCESS = 'CORE_LOAD_LIST_USERGROUPS_SUCCESS';
var CORE_LOAD_LIST_USERGROUPS_FAILURE = 'CORE_LOAD_LIST_USERGROUPS_FAILURE';

var CORE_LOAD_USERGROUP_REQUEST = 'CORE_LOAD_USERGROUP_REQUEST';
var CORE_LOAD_USERGROUP_SUCCESS = 'CORE_LOAD_USERGROUP_SUCCESS';
var CORE_LOAD_USERGROUP_FAILURE = 'CORE_LOAD_USERGROUP_FAILURE';

var CORE_CREATE_USERGROUP_REQUEST = 'CORE_CREATE_USERGROUP_REQUEST';
var CORE_CREATE_USERGROUP_SUCCESS = 'CORE_CREATE_USERGROUP_SUCCESS';
var CORE_CREATE_USERGROUP_FAILURE = 'CORE_CREATE_USERGROUP_FAILURE';

var CORE_UPDATE_USERGROUP_REQUEST = 'CORE_UPDATE_USERGROUP_REQUEST';
var CORE_UPDATE_USERGROUP_SUCCESS = 'CORE_UPDATE_USERGROUP_SUCCESS';
var CORE_UPDATE_USERGROUP_FAILURE = 'CORE_UPDATE_USERGROUP_FAILURE';

var CORE_DELETE_USERGROUP_REQUEST = 'CORE_DELETE_USERGROUP_REQUEST';
var CORE_DELETE_USERGROUP_SUCCESS = 'CORE_DELETE_USERGROUP_SUCCESS';
var CORE_DELETE_USERGROUP_FAILURE = 'CORE_DELETE_USERGROUP_FAILURE';

var CORE_LOAD_ACTIONS_REQUEST = 'CORE_LOAD_ACTIONS_REQUEST';
var CORE_LOAD_ACTIONS_SUCCESS = 'CORE_LOAD_ACTIONS_SUCCESS';
var CORE_LOAD_ACTIONS_FAILURE = 'CORE_LOAD_ACTIONS_FAILURE';

var CORE_LOAD_ALLFBS_REQUEST = 'CORE_LOAD_ALLFBS_REQUEST';
var CORE_LOAD_ALLFBS_SUCCESS = 'CORE_LOAD_ALLFBS_SUCCESS';
var CORE_LOAD_ALLFBS_FAILURE = 'CORE_LOAD_ALLFBS_FAILURE';

var CORE_DELETE_FBS_REQUEST = 'CORE_DELETE_FBS_REQUEST';
var CORE_DELETE_FBS_SUCCESS = 'CORE_DELETE_FBS_SUCCESS';
var CORE_DELETE_FBS_FAILURE = 'CORE_DELETE_FBS_FAILURE';

var CORE_LOAD_FBSINFO_REQUEST = 'CORE_LOAD_FBSINFO_REQUEST';
var CORE_LOAD_FBSINFO_SUCCESS = 'CORE_LOAD_FBSINFO_SUCCESS';
var CORE_LOAD_FBSINFO_FAILURE = 'CORE_LOAD_FBSINFO_FAILURE';

var CORE_CREATE_FBS_REQUEST = 'CORE_CREATE_FBS_REQUEST';
var CORE_CREATE_FBS_SUCCESS = 'CORE_CREATE_FBS_SUCCESS';
var CORE_CREATE_FBS_FAILURE = 'CORE_CREATE_FBS_FAILURE';

var CORE_UPDATE_FBSINFO_REQUEST = 'CORE_UPDATE_FBSINFO_REQUEST';
var CORE_UPDATE_FBSINFO_SUCCESS = 'CORE_UPDATE_FBSINFO_SUCCESS';
var CORE_UPDATE_FBSINFO_FAILURE = 'CORE_UPDATE_FBSINFO_FAILURE';

var CORE_GET_INTEGRATION_INFO_REQUEST = 'CORE_GET_INTEGRATION_INFO_REQUEST';
var CORE_GET_INTEGRATION_INFO_SUCCESS = 'CORE_GET_INTEGRATION_INFO_SUCCESS';
var CORE_GET_INTEGRATION_INFO_FAILURE = 'CORE_GET_INTEGRATION_INFO_FAILURE';

var CORE_LOAD_STATUSUSER_REQUEST = 'CORE_LOAD_STATUSUSER_REQUEST';
var CORE_LOAD_STATUSUSER_SUCCESS = 'CORE_LOAD_STATUSUSER_SUCCESS';
var CORE_LOAD_STATUSUSER_FAILURE = 'CORE_LOAD_STATUSUSER_FAILURE';

var CORE_LOAD_USERSUM_REQUEST = 'CORE_LOAD_USERSUM_REQUEST';
var CORE_LOAD_USERSUM_SUCCESS = 'CORE_LOAD_USERSUM_SUCCESS';
var CORE_LOAD_USERSUM_FAILURE = 'CORE_LOAD_USERSUM_FAILURE';

var CORE_LOAD_ROOMSUM_REQUEST = 'CORE_LOAD_ROOMSUM_REQUEST';
var CORE_LOAD_ROOMSUM_SUCCESS = 'CORE_LOAD_ROOMSUM_SUCCESS';
var CORE_LOAD_ROOMSUM_FAILURE = 'CORE_LOAD_ROOMSUM_FAILURE';

var CORE_LOAD_ROOMTEMP_REQUEST = 'CORE_LOAD_ROOMTEMP_REQUEST';
var CORE_LOAD_ROOMTEMP_SUCCESS = 'CORE_LOAD_ROOMTEMP_SUCCESS';
var CORE_LOAD_ROOMTEMP_FAILURE = 'CORE_LOAD_ROOMTEMP_FAILURE';

var CORE_LOAD_TOPROOMRESERVE_REQUEST = 'CORE_LOAD_TOPROOMRESERVE_REQUEST';
var CORE_LOAD_TOPROOMRESERVE_SUCCESS = 'CORE_LOAD_TOPROOMRESERVE_SUCCESS';
var CORE_LOAD_TOPROOMRESERVE_FAILURE = 'CORE_LOAD_TOPROOMRESERVE_FAILURE';

var CORE_LOAD_TOPUSERRESERVE_REQUEST = 'CORE_LOAD_TOPUSERRESERVE_REQUEST';
var CORE_LOAD_TOPUSERRESERVE_SUCCESS = 'CORE_LOAD_TOPUSERRESERVE_SUCCESS';
var CORE_LOAD_TOPUSERRESERVE_FAILURE = 'CORE_LOAD_TOPUSERRESERVE_FAILURE';

var CORE_LOAD_ROOMDETAIL_REQUEST = 'CORE_LOAD_ROOMDETAIL_REQUEST';
var CORE_LOAD_ROOMDETAIL_SUCCESS = 'CORE_LOAD_ROOMDETAIL_SUCCESS';
var CORE_LOAD_ROOMDETAIL_FAILURE = 'CORE_LOAD_ROOMDETAIL_FAILURE';

var CORE_LOAD_TERM_REQUEST = 'CORE_LOAD_TERM_REQUEST';
var CORE_LOAD_TERM_SUCCESS = 'CORE_LOAD_TERM_SUCCESS';
var CORE_LOAD_TERM_FAILURE = 'CORE_LOAD_TERM_FAILURE';

var CORE_UPDATE_TERM_REQUEST = 'CORE_UPDATE_TERM_REQUEST';
var CORE_UPDATE_TERM_SUCCESS = 'CORE_UPDATE_TERM_SUCCESS';
var CORE_UPDATE_TERM_FAILURE = 'CORE_UPDATE_TERM_FAILURE';

var CORE_LOAD_FAQ_REQUEST = 'CORE_LOAD_FAQ_REQUEST';
var CORE_LOAD_FAQ_SUCCESS = 'CORE_LOAD_FAQ_SUCCESS';
var CORE_LOAD_FAQ_FAILURE = 'CORE_LOAD_FAQ_FAILURE';

var CORE_UPDATE_FAQ_REQUEST = 'CORE_UPDATE_FAQ_REQUEST';
var CORE_UPDATE_FAQ_SUCCESS = 'CORE_UPDATE_FAQ_SUCCESS';
var CORE_UPDATE_FAQ_FAILURE = 'CORE_UPDATE_FAQ_FAILURE';

var CORE_LOAD_CONTACT_US_REQUEST = 'CORE_LOAD_CONTACT_US_REQUEST';
var CORE_LOAD_CONTACT_US_SUCCESS = 'CORE_LOAD_CONTACT_US_SUCCESS';
var CORE_LOAD_CONTACT_US_FAILURE = 'CORE_LOAD_CONTACT_US_FAILURE';

var CORE_UPDATE_CONTACT_US_REQUEST = 'CORE_UPDATE_CONTACT_US_REQUEST';
var CORE_UPDATE_CONTACT_US_SUCCESS = 'CORE_UPDATE_CONTACT_US_SUCCESS';
var CORE_UPDATE_CONTACT_US_FAILURE = 'CORE_UPDATE_CONTACT_US_FAILURE';

var CORE_LOAD_REPORTROOMSTATUS_REQUEST = 'CORE_LOAD_REPORTROOMSTATUS_REQUEST';
var CORE_LOAD_REPORTROOMSTATUS_SUCCESS = 'CORE_LOAD_REPORTROOMSTATUS_SUCCESS';
var CORE_LOAD_REPORTROOMSTATUS_FAILURE = 'CORE_LOAD_REPORTROOMSTATUS_FAILURE';

var CORE_LOAD_ALL_CATEGORY_REQUEST = 'CORE_LOAD_ALL_CATEGORY_REQUEST';
var CORE_LOAD_ALL_CATEGORY_SUCCESS = 'CORE_LOAD_ALL_CATEGORY_SUCCESS';
var CORE_LOAD_ALL_CATEGORY_FAILURE = 'CORE_LOAD_ALL_CATEGORY_FAILURE';

var CORE_LOAD_ALLBUILDING_REQUEST = 'CORE_LOAD_ALLBUILDING_REQUEST';
var CORE_LOAD_ALLBUILDING_SUCCESS = 'CORE_LOAD_ALLBUILDING_SUCCESS';
var CORE_LOAD_ALLBUILDING_FAILURE = 'CORE_LOAD_ALLBUILDING_FAILURE';

var CORE_DELETE_BUILDING_REQUEST = 'CORE_DELETE_BUILDING_REQUEST';
var CORE_DELETE_BUILDING_SUCCESS = 'CORE_DELETE_BUILDING_SUCCESS';
var CORE_DELETE_BUILDING_FAILURE = 'CORE_DELETE_BUILDING_FAILURE';

var CORE_LOAD_BUILDINGINFO_REQUEST = 'CORE_LOAD_BUILDINGINFO_REQUEST';
var CORE_LOAD_BUILDINGINFO_SUCCESS = 'CORE_LOAD_BUILDINGINFO_SUCCESS';
var CORE_LOAD_BUILDINGINFO_FAILURE = 'CORE_LOAD_BUILDINGINFO_FAILURE';

var CORE_UPDATE_BUILDINGINFO_REQUEST = 'CORE_UPDATE_BUILDINGINFO_REQUEST';
var CORE_UPDATE_BUILDINGINFO_SUCCESS = 'CORE_UPDATE_BUILDINGINFO_SUCCESS';
var CORE_UPDATE_BUILDINGINFO_FAILURE = 'CORE_UPDATE_BUILDINGINFO_FAILURE';

var CORE_CREATE_BUILDING_REQUEST = 'CORE_CREATE_BUILDING_REQUEST';
var CORE_CREATE_BUILDING_SUCCESS = 'CORE_CREATE_BUILDING_SUCCESS';
var CORE_CREATE_BUILDING_FAILURE = 'CORE_CREATE_BUILDING_FAILURE';

var CORE_LOAD_ALLFLOOR_REQUEST = 'CORE_LOAD_ALLFLOOR_REQUEST';
var CORE_LOAD_ALLFLOOR_SUCCESS = 'CORE_LOAD_ALLFLOOR_SUCCESS';
var CORE_LOAD_ALLFLOOR_FAILURE = 'CORE_LOAD_ALLFLOOR_FAILURE';

var CORE_DELETE_FLOOR_REQUEST = 'CORE_DELETE_FLOOR_REQUEST';
var CORE_DELETE_FLOOR_SUCCESS = 'CORE_DELETE_FLOOR_SUCCESS';
var CORE_DELETE_FLOOR_FAILURE = 'CORE_DELETE_FLOOR_FAILURE';

var CORE_LOAD_FLOORINFO_REQUEST = 'CORE_LOAD_FLOORINFO_REQUEST';
var CORE_LOAD_FLOORINFO_SUCCESS = 'CORE_LOAD_FLOORINFO_SUCCESS';
var CORE_LOAD_FLOORINFO_FAILURE = 'CORE_LOAD_FLOORINFO_FAILURE';

var CORE_UPDATE_FLOORINFO_REQUEST = 'CORE_UPDATE_FLOORINFO_REQUEST';
var CORE_UPDATE_FLOORINFO_SUCCESS = 'CORE_UPDATE_FLOORINFO_SUCCESS';
var CORE_UPDATE_FLOORINFO_FAILURE = 'CORE_UPDATE_FLOORINFO_FAILURE';

var CORE_CREATE_FLOOR_REQUEST = 'CORE_CREATE_FLOOR_REQUEST';
var CORE_CREATE_FLOOR_SUCCESS = 'CORE_CREATE_FLOOR_SUCCESS';
var CORE_CREATE_FLOOR_FAILURE = 'CORE_CREATE_FLOOR_FAILURE';

var CORE_LOAD_ALLZONE_REQUEST = 'CORE_LOAD_ALLZONE_REQUEST';
var CORE_LOAD_ALLZONE_SUCCESS = 'CORE_LOAD_ALLZONE_SUCCESS';
var CORE_LOAD_ALLZONE_FAILURE = 'CORE_LOAD_ALLZONE_FAILURE';

var CORE_DELETE_ZONE_REQUEST = 'CORE_DELETE_ZONE_REQUEST';
var CORE_DELETE_ZONE_SUCCESS = 'CORE_DELETE_ZONE_SUCCESS';
var CORE_DELETE_ZONE_FAILURE = 'CORE_DELETE_ZONE_FAILURE';

var CORE_LOAD_ZONEINFO_REQUEST = 'CORE_LOAD_ZONEINFO_REQUEST';
var CORE_LOAD_ZONEINFO_SUCCESS = 'CORE_LOAD_ZONEINFO_SUCCESS';
var CORE_LOAD_ZONEINFO_FAILURE = 'CORE_LOAD_ZONEINFO_FAILURE';

var CORE_UPDATE_ZONEINFO_REQUEST = 'CORE_UPDATE_ZONEINFO_REQUEST';
var CORE_UPDATE_ZONEINFO_SUCCESS = 'CORE_UPDATE_ZONEINFO_SUCCESS';
var CORE_UPDATE_ZONEINFO_FAILURE = 'CORE_UPDATE_ZONEINFO_FAILURE';

var CORE_CREATE_ZONE_REQUEST = 'CORE_CREATE_ZONE_REQUEST';
var CORE_CREATE_ZONE_SUCCESS = 'CORE_CREATE_ZONE_SUCCESS';
var CORE_CREATE_ZONE_FAILURE = 'CORE_CREATE_ZONE_FAILURE';

var CORE_LOAD_ALLBACKGROUND_REQUEST = 'CORE_LOAD_ALLBACKGROUND_REQUEST';
var CORE_LOAD_ALLBACKGROUND_SUCCESS = 'CORE_LOAD_ALLBACKGROUND_SUCCESS';
var CORE_LOAD_ALLBACKGROUND_FAILURE = 'CORE_LOAD_ALLBACKGROUND_FAILURE';

var CORE_DELETE_BACKGROUND_REQUEST = 'CORE_DELETE_BACKGROUND_REQUEST';
var CORE_DELETE_BACKGROUND_SUCCESS = 'CORE_DELETE_BACKGROUND_SUCCESS';
var CORE_DELETE_BACKGROUND_FAILURE = 'CORE_DELETE_BACKGROUND_FAILURE';

var CORE_LOAD_BACKGROUNDINFO_REQUEST = 'CORE_LOAD_BACKGROUNDINFO_REQUEST';
var CORE_LOAD_BACKGROUNDINFO_SUCCESS = 'CORE_LOAD_BACKGROUNDINFO_SUCCESS';
var CORE_LOAD_BACKGROUNDINFO_FAILURE = 'CORE_LOAD_BACKGROUNDINFO_FAILURE';

var CORE_UPDATE_BACKGROUNDINFO_REQUEST = 'CORE_UPDATE_BACKGROUNDINFO_REQUEST';
var CORE_UPDATE_BACKGROUNDINFO_SUCCESS = 'CORE_UPDATE_BACKGROUNDINFO_SUCCESS';
var CORE_UPDATE_BACKGROUNDINFO_FAILURE = 'CORE_UPDATE_BACKGROUNDINFO_FAILURE';

var CORE_CREATE_BACKGROUND_REQUEST = 'CORE_CREATE_BACKGROUND_REQUEST';
var CORE_CREATE_BACKGROUND_SUCCESS = 'CORE_CREATE_BACKGROUND_SUCCESS';
var CORE_CREATE_BACKGROUND_FAILURE = 'CORE_CREATE_BACKGROUND_FAILURE';

var CORE_UPDATE_DEFAULTBACKGROUND_REQUEST = 'CORE_UPDATE_DEFAULTBACKGROUND_REQUEST';
var CORE_UPDATE_DEFAULTBACKGROUND_SUCCESS = 'CORE_UPDATE_DEFAULTBACKGROUND_SUCCESS';
var CORE_UPDATE_DEFAULTBACKGROUND_FAILURE = 'CORE_UPDATE_DEFAULTBACKGROUND_FAILURE';

var CORE_GET_CATEGORY_INFO_REQUEST = 'CORE_GET_CATEGORY_INFO_REQUEST';
var CORE_GET_CATEGORY_INFO_SUCCESS = 'CORE_GET_CATEGORY_INFO_SUCCESS';
var CORE_GET_CATEGORY_INFO_FAILURE = 'CORE_GET_CATEGORY_INFO_FAILURE';

var CORE_UPDATE_FB_CATEGORY_REQUEST = 'CORE_UPDATE_FB_CATEGORY_REQUEST';
var CORE_UPDATE_FB_CATEGORY_SUCCESS = 'CORE_UPDATE_FB_CATEGORY_SUCCESS';
var CORE_UPDATE_FB_CATEGORY_FAILURE = 'CORE_UPDATE_FB_CATEGORY_FAILURE';

var CORE_CREATE_FB_CATEGORY_REQUEST = 'CORE_CREATE_FB_CATEGORY_REQUEST';
var CORE_CREATE_FB_CATEGORY_SUCCESS = 'CORE_CREATE_FB_CATEGORY_SUCCESS';
var CORE_CREATE_FB_CATEGORY_FAILURE = 'CORE_CREATE_FB_CATEGORY_FAILURE';

var CORE_DELETE_FB_CATEGORY_REQUEST = 'CORE_DELETE_FB_CATEGORY_REQUEST';
var CORE_DELETE_FB_CATEGORY_SUCCESS = 'CORE_DELETE_FB_CATEGORY_SUCCESS';
var CORE_DELETE_FB_CATEGORY_FAILURE = 'CORE_DELETE_FB_CATEGORY_FAILURE';

var CORE_LOAD_ALL_USERSAD_REQUEST = 'CORE_LOAD_ALL_USERSAD_REQUEST';
var CORE_LOAD_ALL_USERSAD_SUCCESS = 'CORE_LOAD_ALL_USERSAD_SUCCESS';
var CORE_LOAD_ALL_USERSAD_FAILURE = 'CORE_LOAD_ALL_USERSAD_FAILURE';

var CORE_CHECK_AD_REQUEST = 'CORE_CHECK_AD_REQUEST';
var CORE_CHECK_AD_SUCCESS = 'CORE_CHECK_AD_SUCCESS';
var CORE_CHECK_AD_FAILURE = 'CORE_CHECK_AD_FAILURE';

var CORE_LOAD_TIMEZOZE_REQUEST = 'CORE_LOAD_TIMEZOZE_REQUEST';
var CORE_LOAD_TIMEZOZE_SUCCESS = 'CORE_LOAD_TIMEZOZE_SUCCESS';
var CORE_LOAD_TIMEZOZE_FAILURE = 'CORE_LOAD_TIMEZOZE_FAILURE';

var CORE_DELETE_IOT_REQUEST = 'CORE_DELETE_IOT_REQUEST';
var CORE_DELETE_IOT_SUCCESS = 'CORE_DELETE_IOT_SUCCESS';
var CORE_DELETE_IOT_FAILURE = 'CORE_DELETE_IOT_FAILURE';

var CORE_UPDATE_IOT_REQUEST = 'CORE_UPDATE_IOT_REQUEST';
var CORE_UPDATE_IOT_SUCCESS = 'CORE_UPDATE_IOT_SUCCESS';
var CORE_UPDATE_IOT_FAILURE = 'CORE_UPDATE_IOT_FAILURE';

var CORE_CREATE_IOT_REQUEST = 'CORE_CREATE_IOT_REQUEST';
var CORE_CREATE_IOT_SUCCESS = 'CORE_CREATE_IOT_SUCCESS';
var CORE_CREATE_IOT_FAILURE = 'CORE_CREATE_IOT_FAILURE';

var CORE_LOAD_IOT_REQUEST = 'CORE_LOAD_IOT_REQUEST';
var CORE_LOAD_IOT_SUCCESS = 'CORE_LOAD_IOT_SUCCESS';
var CORE_LOAD_IOT_FAILURE = 'CORE_LOAD_IOT_FAILURE';

var CORE_GET_IOT_INFO_REQUEST = 'CORE_GET_IOT_INFO_REQUEST';
var CORE_GET_IOT_INFO_SUCCESS = 'CORE_GET_IOT_INFO_SUCCESS';
var CORE_GET_IOT_INFO_FAILURE = 'CORE_GET_IOT_INFO_FAILURE';

var CORE_EDIT_GOOGLE_INTEGRATION_REQUEST = 'CORE_EDIT_GOOGLE_INTEGRATION_REQUEST';
var CORE_EDIT_GOOGLE_INTEGRATION_SUCCESS = 'CORE_EDIT_GOOGLE_INTEGRATION_SUCCESS';
var CORE_EDIT_GOOGLE_INTEGRATION_FAILURE = 'CORE_EDIT_GOOGLE_INTEGRATION_FAILURE';

var CORE_UPDATE_HOTSEAT_REQUEST = 'CORE_UPDATE_HOTSEAT_REQUEST';
var CORE_UPDATE_HOTSEAT_SUCCESS = 'CORE_UPDATE_HOTSEAT_SUCCESS';
var CORE_UPDATE_HOTSEAT_FAILURE = 'CORE_UPDATE_HOTSEAT_FAILURE';

var CORE_LOAD_ALLSEAT_REQUEST = 'CORE_LOAD_ALLSEAT_REQUEST';
var CORE_LOAD_ALLSEAT_SUCCESS = 'CORE_LOAD_ALLSEAT_SUCCESS';
var CORE_LOAD_ALLSEAT_FAILURE = 'CORE_LOAD_ALLSEAT_FAILURE';

var CORE_LOAD_SEATINFO_REQUEST = 'CORE_LOAD_SEATINFO_REQUEST';
var CORE_LOAD_SEATINFO_SUCCESS = 'CORE_LOAD_SEATINFO_SUCCESS';
var CORE_LOAD_SEATINFO_FAILURE = 'CORE_LOAD_SEATINFO_FAILURE';

var CORE_LOAD_ALLDISABLESEAT_REQUEST = 'CORE_LOAD_ALLDISABLESEAT_REQUEST';
var CORE_LOAD_ALLDISABLESEAT_SUCCESS = 'CORE_LOAD_ALLDISABLESEAT_SUCCESS';
var CORE_LOAD_ALLDISABLESEAT_FAILURE = 'CORE_LOAD_ALLDISABLESEAT_FAILURE';

var CORE_CREATE_DISABLEDSEAT_REQUEST = 'CORE_CREATE_DISABLEDSEAT_REQUEST';
var CORE_CREATE_DISABLEDSEAT_SUCCESS = 'CORE_CREATE_DISABLEDSEAT_SUCCESS';
var CORE_CREATE_DISABLEDSEAT_FAILURE = 'CORE_CREATE_DISABLEDSEAT_FAILURE';

var CORE_LOAD_DISABLESEATINFO_REQUEST = 'CORE_LOAD_DISABLESEATINFO_REQUEST';
var CORE_LOAD_DISABLESEATINFO_SUCCESS = 'CORE_LOAD_DISABLESEATINFO_SUCCESS';
var CORE_LOAD_DISABLESEATINFO_FAILURE = 'CORE_LOAD_DISABLESEATINFO_FAILURE';

var CORE_UPDATE_DISABLESEATINFO_REQUEST = 'CORE_UPDATE_DISABLESEATINFO_REQUEST';
var CORE_UPDATE_DISABLESEATINFO_SUCCESS = 'CORE_UPDATE_DISABLESEATINFO_SUCCESS';
var CORE_UPDATE_DISABLESEATINFO_FAILURE = 'CORE_UPDATE_DISABLESEATINFO_FAILURE';

var CORE_DELETE_DISABLESEATINFO_REQUEST = 'CORE_DELETE_DISABLESEATINFO_REQUEST';
var CORE_DELETE_DISABLESEATINFO_SUCCESS = 'CORE_DELETE_DISABLESEATINFO_SUCCESS';
var CORE_DELETE_DISABLESEATINFO_FAILURE = 'CORE_DELETE_DISABLESEATINFO_FAILURE';

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 402, 403, 404, 422, 500];

function getAction(type, action, state, res) {
	return new Promise(function (resolve, reject) {
		if (!res) return resolve({ type: type });

		if (resStatusError.includes(res.status)) {
			if (res.status === 422) {
				return res.json().then(function (json) {
					var message = "";
					for (var key in json) {
						if (json.hasOwnProperty(key)) {
							var element = json[key];
							for (var k in element) {
								if (element.hasOwnProperty(k)) {
									var ele = element[k];
									message += '' + ele.msg;
									if (ele.param) message += ' Param : ' + (ele.param + ' ');
									message += "\n";
								}
							}
						}
					}

					return reject({
						statusText: res.statusText, data: {
							code: res.status.toString(),
							message: message
						}
					});
				});
			} else {
				return res.json().then(function (data) {
					return reject({ statusText: res.statusText, data: data });
				});
			}
		}

		if ((typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object') {
			if (type.payload) {
				var payload = type.payload(action, state, res);
				if (typeof payload.then === 'function') {
					//promise
					return payload.then(function (data) {
						return resolve({ type: type.type, payload: data });
					});
				} else {
					return resolve({ type: type.type, payload: payload });
				}
			}

			return resolve({ type: type.type });
		}

		res.json().then(function (payload) {
			return resolve({ type: type, payload: payload });
		});
	});
}

/* harmony default export */ var api = (function (_ref) {
	var getState = _ref.getState;
	return function (next) {
		return function (action) {
			if (_typeof(action[CALL_API]) !== 'object') return next(action);
			var _action$CALL_API = action[CALL_API],
			    endpoint = _action$CALL_API.endpoint,
			    _action$CALL_API$meth = _action$CALL_API.method,
			    method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
			    headers = _action$CALL_API.headers,
			    body = _action$CALL_API.body,
			    types = _action$CALL_API.types;

			var _types = _slicedToArray(types, 3),
			    request = _types[0],
			    success = _types[1],
			    failure = _types[2];

			var callBack = success.callBack;

			var state = getState();

			getAction(request, action, state).then(function (action) {
				return next(action);
			});

			if (callBack) {
				fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
					return getAction(success, action, state, res);
				}).then(function (action) {
					callBack(action);
					next(action);
				}).catch(function (err) {
					return next({ type: failure, payload: err, error: true, errorData: err.data });
				});
			} else {
				fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
					return getAction(success, action, state, res);
				}).then(function (action) {
					return next(action);
				}).catch(function (err) {
					return next({ type: failure, payload: err, error: true, errorData: err.data });
				});
			}
		};
	};
});
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(522);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);

// EXTERNAL MODULE: ./src/lib/index.js + 5 modules
var lib = __webpack_require__(70);

// CONCATENATED MODULE: ./src/middlewares/checkToken.js
var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];
            var currentTime = moment_timezone_default()().format(lib["x" /* timeFormat */]);

            if ((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object') return next(action);

            if (typeof entry !== "undefined") {
                if (typeof entry.tokentype !== "undefined" && entry.tokentype) {
                    var _getServiceToken = Object(lib["n" /* getServiceToken */])(),
                        service_token = _getServiceToken.service_token,
                        service_expires_on = _getServiceToken.service_expires_on;

                    if (!service_token) return next(action);

                    var serviceDuration = moment_timezone_default.a.duration(moment_timezone_default.a.unix(service_expires_on).diff(currentTime));
                    var serviceMinutes = serviceDuration.asMinutes();

                    var bsrs_token = Object(lib["g" /* getBSRSToken */])();
                    if (serviceMinutes < 10) {
                        console.log('request new service token');
                        fetch(lib["a" /* CORE_API_ENDPOINT */] + '/o365/service_token', {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + bsrs_token
                            }
                        }).then(function (res) {
                            return res.json();
                        }).then(function (json) {
                            return Object(lib["v" /* setServiceToken */])(json);
                        }).then(function () {
                            return next(action);
                        });
                    } else {
                        next(action);
                    }
                }
            }

            var isO365 = entry.types[0].startsWith("O365");

            if (isO365) {
                var token = Object(lib["e" /* getAccessToken */])();

                if (!token) return next(action);

                var _getAllToken = Object(lib["f" /* getAllToken */])(),
                    expires_on = _getAllToken.expires_on,
                    refresh_token = _getAllToken.refresh_token;

                var _currentTime = moment_timezone_default()().format(lib["x" /* timeFormat */]);
                var duration = moment_timezone_default.a.duration(moment_timezone_default.a.unix(expires_on).diff(_currentTime));
                var minutes = duration.asMinutes();

                if (minutes < 10) {
                    console.log('request new token');
                    fetch(lib["a" /* CORE_API_ENDPOINT */] + '/o365/refresh_token', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ refresh_token: refresh_token })
                    }).then(function (res) {
                        return res.json();
                    }).then(function (json) {
                        return Object(lib["w" /* setToken */])(json);
                    }).then(function () {
                        return next(action);
                    });
                } else {
                    next(action);
                }
            } else {
                next(action);
            }
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/setToken.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/* harmony default export */ var setToken = (function (store) {
  return function (next) {
    return function (action) {
      var entry = action[CALL_API];

      if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

      var token = void 0;
      var entryType = entry.types[0];
      if (entryType.startsWith("CORE") || entryType.startsWith("O365")) {
        token = Object(lib["g" /* getBSRSToken */])();
      }
      // else if (entryType.startsWith("O365")) {
      //   const { service_token } = getServiceToken()
      //   token = service_token
      // }

      // if(entryType.startsWith("CORE")){
      //   token = getBSRSToken()
      // }else if(entry.types[0].startsWith("O365")){ 
      //   if(typeof(entry.tokentype) !== undefined && entry.tokentype === 'service' ){ 
      //     const { service_token } = getServiceToken()
      //     token = service_token
      //   }
      //   else token = getAccessToken()
      // }

      if (!token) return next(action);

      entry.headers = _extends({}, entry.headers, { 'Authorization': 'Bearer ' + token });

      next(action);
    };
  };
});
// CONCATENATED MODULE: ./src/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 476:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_loadable__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var Loading = function Loading() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { height: '100vh' } },
        'Loading...'
    );
};

/* harmony default export */ __webpack_exports__["a"] = (function (opts) {
    return __WEBPACK_IMPORTED_MODULE_1_react_loadable___default()(_extends({
        loading: Loading
    }, opts));
});

/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CORE_API_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return O365_API_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NOTI_API_ENDPOINT; });
// export const CORE_API_ENDPOINT = 'https://www.bainisysstg.com/core'
var CORE_API_ENDPOINT = '/core';
var O365_API_ENDPOINT = '/o365';
var NOTI_API_ENDPOINT = '/notification';

/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = authorizeO365;
/* unused harmony export authorizeProfile */
/* harmony export (immutable) */ __webpack_exports__["a"] = authorizeBSRS;
/* harmony export (immutable) */ __webpack_exports__["c"] = authorizeServiceToken;
/* harmony export (immutable) */ __webpack_exports__["d"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Lib__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Middlewares__ = __webpack_require__(221);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






function authorizeO365(code) {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_1_Lib__["a" /* CORE_API_ENDPOINT */] + '/o365/token',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ code: code }),
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["_312" /* O365_REGISTER_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["_313" /* O365_REGISTER_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    var access_token = json.access_token,
                        expires_on = json.expires_on,
                        refresh_token = json.refresh_token;


                    var token = {
                        access_token: access_token,
                        expires_on: expires_on,
                        refresh_token: refresh_token
                    };

                    Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["w" /* setToken */])(token);
                    return { token: token };
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["_311" /* O365_REGISTER_FAILURE */]]
    });
}

function authorizeProfile(_ref2) {
    var email = _ref2.email,
        password = _ref2.password;

    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2_Middlewares__["a" /* CALL_API */], {
        endpoint: 'https://www.bsrsprofile.com/center/profile/verify',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: email, password: password }),
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["_318" /* PROFILE_LOGIN_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["_319" /* PROFILE_LOGIN_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    var _json$profile = json.profile,
                        room = _json$profile.room,
                        appMeta = _json$profile.appMeta;
                    var client_id = appMeta.client_id,
                        api_server_url = appMeta.api_server_url;

                    Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["u" /* setRoomToken */])(room, client_id, api_server_url);
                    return { room: room };
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["_317" /* PROFILE_LOGIN_FAILURE */]]
    });
}

function authorizeBSRS(_ref4) {
    var emailaddress = _ref4.emailaddress,
        password = _ref4.password;

    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_1_Lib__["a" /* CORE_API_ENDPOINT */] + '/user/adminverify',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: emailaddress, password: password }),
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["b" /* BSRS_LOGIN_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["c" /* BSRS_LOGIN_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    var isIntegration = json.isIntegration,
                        _json$isUserActiveDir = json.isUserActiveDirectory,
                        isUserActiveDirectory = _json$isUserActiveDir === undefined ? isUserActiveDirectory ? isUserActiveDirectory : false : _json$isUserActiveDir,
                        token = json.token,
                        user = json.user,
                        company = json.company,
                        system_key = json.system_key;
                    var id = user.id,
                        firstName = user.firstName,
                        email = user.email;
                    // const { access_token, expires_on } = serviceToken

                    var bsrsToken = { isIntegration: isIntegration, /* access_token, expires_on,*/token: token, id: id, company: company, firstName: firstName, email: email, isUserActiveDirectory: isUserActiveDirectory, system_key: system_key };
                    Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["s" /* setBSRSToken */])(bsrsToken);
                    return { bsrsToken: bsrsToken };
                });
            },
            callBack: function callBack(data) {
                var payload = data.payload;
                if (payload.bsrsToken) {
                    window.location.replace('/');
                }
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* BSRS_LOGIN_FAILURE */]]
    });
}

function authorizeServiceToken(history) {
    var bsrsToken = Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["g" /* getBSRSToken */])();
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_1_Lib__["a" /* CORE_API_ENDPOINT */] + '/o365/service_token',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bsrsToken
        },
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["e" /* BSRS_SERVICE_TOKEN_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["f" /* BSRS_SERVICE_TOKEN_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    var token = json.token,
                        expires_on = json.expires_on;

                    var serviceToken = {
                        token: token,
                        expires_on: expires_on
                    };
                    if (typeof token === 'undefined') history.push('/settings/integration');else {
                        Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["v" /* setServiceToken */])(serviceToken);
                        return { serviceToken: serviceToken };
                    }
                });
            },
            callBack: function callBack() {
                // history.push(`/room`)
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["d" /* BSRS_SERVICE_TOKEN_FAILURE */]]
    });
}

function logout() {
    Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["d" /* clearBSRSToken */])();
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__types__["_274" /* LOGOUT */]
    };
}

/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/types.js
var types = __webpack_require__(17);

// CONCATENATED MODULE: ./src/error.js

// 0000 => api error
// 0001 => backend error
// 0002 => fronted error

var errorMessage = {
	// default error
	"00010000": "Something went wrong. Please try again later.",

	// custom error
	"00010001": "asfsdfdsfdsf sdfdsf dsf"
};

/* harmony default export */ var src_error = ({
	errorMessage: errorMessage
});
// CONCATENATED MODULE: ./src/features/ui/actions.js
/* harmony export (immutable) */ __webpack_exports__["a"] = setError;





function setError(hasError) {
	var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


	var defaultError = {
		code: "00010000",
		message: /* Cannot get final name for export "errorMessage" in "./src/error.js" (known exports: default, known reexports: ) */ undefined ? /* Cannot get final name for export "errorMessage" in "./src/error.js" (known exports: default, known reexports: ) */ undefined["00010000"] : ""
	};

	if (typeof error === 'string' && error in /* Cannot get final name for export "errorMessage" in "./src/error.js" (known exports: default, known reexports: ) */ undefined) {
		defaultError = {
			code: error,
			message: /* Cannot get final name for export "errorMessage" in "./src/error.js" (known exports: default, known reexports: ) */ undefined[error]
		};
	} else if (error != null && error != undefined && error.code != undefined && error.message != undefined) {
		defaultError = error;
	} else if (error == null || hasError == false) {
		defaultError = null;
	}

	return {
		type: types["_320" /* SET_ERROR */],
		hasError: hasError,
		error: defaultError
	};
}

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(496);


/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root__);





var render = function render(Component) {
    return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__["AppContainer"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

render(__WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root___default.a);

if (false) {
    module.hot.accept('./features/ui/components/Root', function () {
        return render(RootContainer);
    });
}

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(504);
} else {
    module.exports = require('./Root.dev');
}

/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 30 modules
var es = __webpack_require__(71);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var react_redux_es = __webpack_require__(24);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/src/index.js
var src = __webpack_require__(513);
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// CONCATENATED MODULE: ./src/store/schema.js


var eventSchema = new src["schema"].Entity('events');
// EXTERNAL MODULE: ./src/store/configureStore.js
var configureStore = __webpack_require__(519);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/store/index.js


// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(72);

// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 242 modules
var dist_es = __webpack_require__(83);

// CONCATENATED MODULE: ./src/features/ui/selectors.js
function getIsLoading(state) {
    return state.ui.isLoading;
}

function getHasError(state) {
    return state.ui.hasError;
}

function getError(state) {
    return state.ui.error;
}

function getHasBSRSLoginFail(state) {
    return state.ui.hasBSRSLoginFail === true;
}
// EXTERNAL MODULE: ./src/features/ui/actions.js + 1 modules
var actions = __webpack_require__(494);

// CONCATENATED MODULE: ./src/features/ui/components/ErrorMessageDialog.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ErrorMessageDialog_ErrorMessage = function (_React$Component) {
	_inherits(ErrorMessage, _React$Component);

	function ErrorMessage() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, ErrorMessage);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ErrorMessage.__proto__ || Object.getPrototypeOf(ErrorMessage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { open: _this.props.hasError }, _this.close = function () {
			_this.setState({ open: false });
			_this.props.clearError();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(ErrorMessage, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProp) {
			this.setState({ open: nextProp.hasError });
		}
	}, {
		key: 'render',
		value: function render() {
			return react_default.a.createElement(
				dist_es["s" /* Modal */],
				{ open: this.state.open, onClose: this.close },
				react_default.a.createElement(
					dist_es["s" /* Modal */].Header,
					null,
					'System Message'
				),
				react_default.a.createElement(
					dist_es["s" /* Modal */].Content,
					null,
					this.props.hasError && this.props.error != null && this.props.error.code != undefined && this.props.error.message != undefined && react_default.a.createElement(
						dist_es["s" /* Modal */].Description,
						null,
						react_default.a.createElement(
							'p',
							null,
							'Error Code : ',
							this.props.error.code
						),
						react_default.a.createElement(
							'p',
							null,
							'Error Message : ',
							this.props.error.message
						)
					)
				),
				react_default.a.createElement(
					dist_es["s" /* Modal */].Actions,
					null,
					react_default.a.createElement(dist_es["a" /* Button */], {
						positive: true,
						icon: 'checkmark',
						labelPosition: 'right',
						content: 'OK',
						onClick: this.close,
						onClose: this.close
					})
				)
			);
		}
	}]);

	return ErrorMessage;
}(react_default.a.Component);

/* harmony default export */ var ErrorMessageDialog = (Object(Recompose["b" /* compose */])(Object(react_redux_es["connect"])(function (state, props) {
	return {
		hasError: getHasError(state),
		error: getError(state)
	};
}, function (dispatch) {
	return {
		clearError: function clearError() {
			dispatch(Object(actions["a" /* setError */])(false));
		}
	};
}))(ErrorMessageDialog_ErrorMessage));
// CONCATENATED MODULE: ./src/features/ui/components/Loading.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var Loading_LoadingComponent = function LoadingComponent(props) {
	return props.isLoading ? react_default.a.createElement(
		dist_es["e" /* Dimmer */],
		{ active: true },
		react_default.a.createElement(
			dist_es["p" /* Loader */],
			{ size: 'large' },
			'Loading'
		)
	) : "";
};

/* harmony default export */ var Loading = (Object(Recompose["b" /* compose */])(Object(react_redux_es["connect"])(function (state) {
	return {
		isLoading: getIsLoading(state)
	};
}), Object(Recompose["f" /* withProps */])(function (props) {
	return _extends({}, props);
}))(Loading_LoadingComponent));
// EXTERNAL MODULE: ./src/features/auth/actions.js
var auth_actions = __webpack_require__(493);

// EXTERNAL MODULE: ./src/features/auth/selectors.js
var selectors = __webpack_require__(119);

// EXTERNAL MODULE: ./src/lib/index.js + 5 modules
var lib = __webpack_require__(70);

// CONCATENATED MODULE: ./src/features/ui/components/Header.js
var Header__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// const trigger = (
//     <span><Icon name='user' /></span>
// )
var header = {
    textDecoration: 'underline',
    fontSize: '1em'
};

var Header_NoAuthHeader = function NoAuthHeader() {
    return react_default.a.createElement('div', null);
};

// const AuthHeader = ({ logout }) => (

var Header_AuthHeader = function (_React$Component) {
    Header__inherits(AuthHeader, _React$Component);

    function AuthHeader(props) {
        Header__classCallCheck(this, AuthHeader);

        var _this = Header__possibleConstructorReturn(this, (AuthHeader.__proto__ || Object.getPrototypeOf(AuthHeader)).call(this, props));

        var bsrs = Object(lib["n" /* getServiceToken */])();
        var firstName = Object(lib["p" /* getUserFirstName */])();
        var isUseAD = Object(lib["i" /* getIsUserActiveDirectory */])();
        var system = Object(lib["o" /* getSystem */])();
        var user_id = bsrs.user_id;

        _this.state = {
            // isProfile: user_id === 'profile_user' ? true : false,
            isProfile: true,
            logout: props.logout,
            firstName: typeof firstName !== 'undefined' ? firstName : '',
            isUseAD: isUseAD ? isUseAD : false,
            system: system
        };
        return _this;
    }

    Header__createClass(AuthHeader, [{
        key: 'render',
        value: function render() {
            var linkToInt = '';
            if (Object(lib["o" /* getSystem */])() === 'o365') linkToInt = '/integration';else if (Object(lib["o" /* getSystem */])() === 'exchange2013') linkToInt = '/exchangeIntegration';else if (Object(lib["o" /* getSystem */])() === 'google') linkToInt = '/googleIntegration';
            return react_default.a.createElement(
                dist_es["q" /* Menu */],
                { secondary: true, fixed: 'top', style: { backgroundColor: "rgb(51, 51, 51)" } },
                react_default.a.createElement(
                    dist_es["d" /* Container */],
                    null,
                    react_default.a.createElement(
                        dist_es["q" /* Menu */].Item,
                        { as: es["b" /* Link */], to: '/', className: 'menuImage' },
                        react_default.a.createElement(dist_es["l" /* Image */], {
                            size: 'small',
                            src: '/assets/images/logo.png',
                            style: { marginRight: '1em' }
                        })
                    ),
                    react_default.a.createElement(
                        dist_es["g" /* Dropdown */],
                        { item: true, text: 'Meeting Room', id: 'menuHover' },
                        react_default.a.createElement(
                            dist_es["g" /* Dropdown */].Menu,
                            null,
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */],
                                { item: true, text: 'Rooms' },
                                react_default.a.createElement(
                                    dist_es["g" /* Dropdown */].Menu,
                                    null,
                                    react_default.a.createElement(
                                        dist_es["g" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/room/o365' },
                                        react_default.a.createElement(dist_es["k" /* Icon */], { name: 'window restore' }),
                                        'O365 Rooms'
                                    ),
                                    react_default.a.createElement(
                                        dist_es["g" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/room/core' },
                                        react_default.a.createElement(dist_es["k" /* Icon */], { name: 'database' }),
                                        'Regis Rooms'
                                    ),
                                    react_default.a.createElement(
                                        dist_es["g" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/room/subscribe' },
                                        react_default.a.createElement(dist_es["k" /* Icon */], { name: 'bell' }),
                                        'Rooms Subscribe'
                                    )
                                )
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */],
                                { item: true, text: 'Location' },
                                react_default.a.createElement(
                                    dist_es["g" /* Dropdown */].Menu,
                                    null,
                                    react_default.a.createElement(
                                        dist_es["g" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/building' },
                                        react_default.a.createElement(dist_es["k" /* Icon */], { name: 'building' }),
                                        'Building'
                                    ),
                                    react_default.a.createElement(
                                        dist_es["g" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/floor' },
                                        react_default.a.createElement(dist_es["k" /* Icon */], { name: 'hashtag' }),
                                        'Floor'
                                    ),
                                    react_default.a.createElement(
                                        dist_es["g" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/zone' },
                                        react_default.a.createElement(dist_es["k" /* Icon */], { name: 'star' }),
                                        'Zone'
                                    )
                                )
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/iot' },
                                react_default.a.createElement(dist_es["k" /* Icon */], { name: 'at' }),
                                'Iot'
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/profile/list' },
                                react_default.a.createElement(dist_es["k" /* Icon */], { name: 'user' }),
                                'Profile'
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/background' },
                                react_default.a.createElement(dist_es["k" /* Icon */], { name: 'flag' }),
                                'Background'
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/amenity' },
                                react_default.a.createElement(dist_es["k" /* Icon */], { name: 'briefcase' }),
                                'Amenity'
                            )
                        )
                    ),
                    react_default.a.createElement(
                        dist_es["g" /* Dropdown */],
                        { item: true, text: 'Users', id: 'menuHover' },
                        react_default.a.createElement(
                            dist_es["g" /* Dropdown */].Menu,
                            null,
                            this.state.isUseAD === 'true' && react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/user/ad' },
                                react_default.a.createElement(dist_es["k" /* Icon */], { name: 'adn' }),
                                'AD User'
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/user/core' },
                                react_default.a.createElement(dist_es["k" /* Icon */], { name: 'database' }),
                                'Regis User'
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/user/group/list' },
                                react_default.a.createElement(dist_es["k" /* Icon */], { name: 'users' }),
                                'User Group'
                            )
                        )
                    ),
                    react_default.a.createElement(
                        dist_es["g" /* Dropdown */],
                        { item: true, text: 'Settings', id: 'menuHover' },
                        react_default.a.createElement(
                            dist_es["g" /* Dropdown */].Menu,
                            null,
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/setting' },
                                react_default.a.createElement(dist_es["k" /* Icon */], { name: 'setting' }),
                                'Setting'
                            ),
                            this.state.isProfile && react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: linkToInt },
                                react_default.a.createElement(dist_es["k" /* Icon */], { name: 'cogs' }),
                                'Integration'
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/term' },
                                react_default.a.createElement(dist_es["k" /* Icon */], { name: 'setting' }),
                                'Terms & Conditions'
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/faq' },
                                react_default.a.createElement(dist_es["k" /* Icon */], { name: 'setting' }),
                                'FAQ'
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/contact' },
                                react_default.a.createElement(dist_es["k" /* Icon */], { name: 'setting' }),
                                'Contact Us'
                            )
                        )
                    ),
                    react_default.a.createElement(
                        dist_es["g" /* Dropdown */],
                        { item: true, text: 'Report', id: 'menuHover' },
                        react_default.a.createElement(
                            dist_es["g" /* Dropdown */].Menu,
                            null,
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Header,
                                { style: header },
                                'Summary'
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/roomsummary' },
                                ' Room Summary'
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/usersummary' },
                                ' User Summary'
                            ),
                            react_default.a.createElement(dist_es["g" /* Dropdown */].Divider, null),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Header,
                                { style: header },
                                'Detail'
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/roomreport' },
                                'Room Detail'
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/userreport' },
                                'User Detail'
                            )
                        )
                    ),
                    react_default.a.createElement(
                        dist_es["g" /* Dropdown */],
                        { item: true, text: 'Monitor', id: 'menuHover' },
                        react_default.a.createElement(
                            dist_es["g" /* Dropdown */].Menu,
                            null,
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Header,
                                { style: header },
                                'Summary'
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/statussummary' },
                                'Overview'
                            ),
                            react_default.a.createElement(dist_es["g" /* Dropdown */].Divider, null),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Header,
                                { style: header },
                                'Status'
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/overview' },
                                'Room'
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/overview/user/day' },
                                'Top User By Reserve'
                            ),
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/overview/room/day' },
                                'Top Room By Reserve'
                            )
                        )
                    ),
                    react_default.a.createElement(
                        dist_es["q" /* Menu */].Menu,
                        { position: 'right' },
                        react_default.a.createElement(
                            dist_es["g" /* Dropdown */],
                            { item: true, text: 'Hello, ' + this.state.firstName, id: 'lastMenuHover' },
                            react_default.a.createElement(
                                dist_es["g" /* Dropdown */].Menu,
                                null,
                                react_default.a.createElement(
                                    dist_es["g" /* Dropdown */].Item,
                                    { as: es["b" /* Link */], to: '/UserInfo' },
                                    'User Information'
                                ),
                                react_default.a.createElement(
                                    dist_es["g" /* Dropdown */].Item,
                                    { onClick: this.state.logout },
                                    '  ',
                                    react_default.a.createElement(dist_es["k" /* Icon */], { name: 'power' }),
                                    'Sign Out'
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return AuthHeader;
}(react_default.a.Component);

var Header_Header = function Header(_ref) {
    var isLoggedIn = _ref.isLoggedIn,
        logout = _ref.logout;
    return react_default.a.createElement(
        'div',
        null,
        isLoggedIn ? react_default.a.createElement(Header_AuthHeader, { logout: logout }) : react_default.a.createElement(Header_NoAuthHeader, null)
    );
};

/* harmony default export */ var components_Header = (Object(Recompose["b" /* compose */])(es["f" /* withRouter */], Object(react_redux_es["connect"])(function (state) {
    return { isLoggedIn: Object(selectors["a" /* getIsLoggedIn */])(state) };
}, function (dispatch, props) {
    return {
        logout: function logout() {

            dispatch(Object(auth_actions["d" /* logout */])());
            props.history.push('/login');
        }
    };
}))(Header_Header));
// EXTERNAL MODULE: ./src/features/ui/components/Loadable.js
var Loadable = __webpack_require__(476);

// CONCATENATED MODULE: ./src/lib/routePermission.js
var routePermission__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var Auth = {
	isAuthenticated: function isAuthenticated() {
		var bsrsToken = Object(lib["g" /* getBSRSToken */])();
		// const serviceToken = getServiceToken()

		return !!bsrsToken; /*&& !!serviceToken.service_token*/
	},
	isIntegration: function isIntegration() {
		return true;
	}
};

var routePermission_PrivateRoute = function PrivateRoute(_ref) {
	var Component = _ref.component,
	    rest = _objectWithoutProperties(_ref, ['component']);

	return react_default.a.createElement(es["d" /* Route */], routePermission__extends({}, rest, { render: function render(props) {

			if (Auth.isAuthenticated() == false && props.match.url != "/login") {
				return react_default.a.createElement(es["c" /* Redirect */], { to: '/login' });
			}

			if (Auth.isIntegration() == false && props.match.url != "/integration") {
				return react_default.a.createElement(es["c" /* Redirect */], { to: '/integration' });
			}

			if (Component != undefined) {
				return react_default.a.createElement(Component, props);
			} else {
				return react_default.a.createElement(es["c" /* Redirect */], { to: '/' });
			}
		} }));
};

var routePermission_PublicRoute = function PublicRoute(_ref2) {
	var Component = _ref2.component,
	    rest = _objectWithoutProperties(_ref2, ['component']);

	return react_default.a.createElement(es["d" /* Route */], routePermission__extends({}, rest, { render: function render(props) {

			if (Auth.isAuthenticated() == true && props.match.url == "/login") {
				return react_default.a.createElement(es["c" /* Redirect */], { to: '/' });
			}

			if (Component != undefined) {
				return react_default.a.createElement(Component, props);
			} else {
				return "";
			}
		} }));
};

/* harmony default export */ var routePermission = ({
	PrivateRoute: routePermission_PrivateRoute,
	PublicRoute: routePermission_PublicRoute
});
// CONCATENATED MODULE: ./src/features/ui/components/Routes.js





var AsyncHome = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 1378));
	}
});

var AsyncNotFound = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 1379));
	}
});

var AsyncLoginBSRS = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 1380));
	}
});

var AsyncSettings = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 1381));
	}
});

var AsyncSettingsIntegration = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1382));
	}
});

var AsyncCreateRoom = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1385));
	}
});

var AsyncUpdateRoom = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1386));
	}
});

var AsyncSettingsRoom = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1387));
	}
});

var AsyncLoginO365 = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 1388));
	}
});

var AsyncAuthorizeO365 = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1389));
	}
});

var AsyncCheckRoomInCore = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1390));
	}
});

var AsyncRoomInCore = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1391));
	}
});

// const AsyncUserSetting = Loadable({
//     loader: () => import(/* webpackChunkName: "AuthorizeO365" */ '../../settings/user/components/UserSetting') 
// })

var AsyncUserList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1392));
	}
});

var AsyncUserAdd = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1393));
	}
});

var AsyncUserEdit = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1394));
	}
});

var AsyncUserchangePass = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1395));
	}
});

var AsyncUserInfo = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1396));
	}
});

var AsyncUserChangePassword = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 1397));
	}
});

// const AsyncIntegrations = Loadable({
//     loader: () => import('../../settings/integration/components/Integrations')
// })

var AsyncReportSummary = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1398));
	}
});

var AsyncUserReport = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1399));
	}
});

var AsyncRoomReportNew = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1400));
	}
});

var AsyncUserSummary = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1401));
	}
});

var AsyncRoomSummary = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1402));
	}
});

var AsyncSetting = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 1403));
	}
});

var AsyncChangeSetting = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1404));
	}
});

var AsyncListRoomsO365 = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1405));
	}
});

var AsyncListRoomsCore = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1406));
	}
});

var AsyncListRoomsSubscribe = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1407));
	}
});

var AsyncCreateRoomNew = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1408));
	}
});

var AsyncUpdateRoomNew = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1409));
	}
});

var AsyncViewRoomCore = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1410));
	}
});

var AsyncListUsersCore = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1411));
	}
});

var AsyncListUsersO365 = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1412));
	}
});

var AsyncListUsersAD = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1413));
	}
});

var AsyncCreateUser = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 1414));
	}
});

var AsyncUpdateUser = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 1415));
	}
});

var AsyncViewUserCore = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1416));
	}
});

var AsyncAmenity = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1417));
	}
});

var AsyncAmenityUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 1418));
	}
});

var AsyncViewAmenity = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1419));
	}
});

var AsyncAmenityCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 1420));
	}
});

var AsyncBuildingCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 1421));
	}
});
var AsyncBuildingUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 1422));
	}
});
var AsyncViewBuilding = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1423));
	}
});
var AsyncBuilding = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1424));
	}
});

var AsyncBackgroundCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 1425));
	}
});
var AsyncBackgroundUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 1426));
	}
});
var AsyncViewBackground = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1427));
	}
});
var AsyncBackground = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1428));
	}
});

var AsyncFloorCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1429));
	}
});
var AsyncFloorUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1430));
	}
});
var AsyncViewFloor = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1431));
	}
});
var AsyncFloor = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1432));
	}
});

var AsyncZoneCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1433));
	}
});
var AsyncZoneUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1434));
	}
});
var AsyncViewZone = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1435));
	}
});
var AsyncZone = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1436));
	}
});

var AsyncFbs = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1437));
	}
});

var AsyncFbsUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 1438));
	}
});

var AsyncViewFbs = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1439));
	}
});

var AsyncFbsCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 1440));
	}
});

var AsyncListUserGroup = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1441));
	}
});

var AsyncCreateUserGroup = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 1442));
	}
});

var AsyncUpdateUserGroup = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 1443));
	}
});

var AsyncViewUserGroup = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1444));
	}
});

var AsyncCreateProfile = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1445));
	}
});

var AsyncListProfile = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1446));
	}
});

var AsyncUpdateProfile = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1447));
	}
});

var AsyncViewProfile = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 1448));
	}
});

var AsyncIntegrations = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 1449));
	}
});

var AsyncReportOverview = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1450));
	}
});

var AsyncReportByRoom = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1451));
	}
});

var AsyncReportByUser = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1452));
	}
});

var AsyncReportRoomDetail = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1453));
	}
});

var AsyncReportUserDetail = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1454));
	}
});

var AsyncReportOverviewDetail = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1455));
	}
});

var AsyncTerm = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1456));
	}
});

var AsyncEditTerm = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1457));
	}
});

var AsyncFaq = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1458));
	}
});

var AsyncEditFaq = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1459));
	}
});

var AsyncContactUs = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1460));
	}
});

var AsyncEditContactUs = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1461));
	}
});

var AsyncFbsCategory = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1462));
	}
});

var AsyncUpdateFbsCategory = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 1463));
	}
});

var AsyncCreateFbsCategory = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 1464));
	}
});

var AsyncIot = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1465));
	}
});

var AsyncIotUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1466));
	}
});

var AsyncExchangeIntegrations = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 1467));
	}
});

var AsyncGoogleIntegrations = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 1468));
	}
});

var AsyncSettingsGoogleIntegration = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1469));
	}
});

var AsyncSettingsExchangeIntegration = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 1470));
	}
});

var AsyncRegisterSeat = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1471));
	}
});

var AsyncDisableSeat = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1472));
	}
});

var AsyncDisableSeatCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1473));
	}
});

var AsyncDisableSeatUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1474));
	}
});

// const AsyncCreateRegisterSeat = Loadable({
// 	loader: () => import('../../hotseat/components/pages/createHotseat')
// })

var AsyncUpdateRegisterSeat = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1475));
	}
});

var AsyncCreateRegisterSeat = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1476));
	}
});

var AsyncRoomQRCode = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1477));
	}
});

/* harmony default export */ var Routes = (function () {
	return react_default.a.createElement(
		es["e" /* Switch */],
		null,
		react_default.a.createElement(routePermission.PrivateRoute, { exact: true, path: '/', component: AsyncHome }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/integration', component: AsyncIntegrations }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/exchangeIntegration', component: AsyncExchangeIntegrations }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/googleIntegration', component: AsyncGoogleIntegrations }),
		react_default.a.createElement(routePermission.PublicRoute, { path: '/login', component: AsyncLoginBSRS }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/settings/integration', component: AsyncSettingsIntegration }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/settings/googleIntegration', component: AsyncSettingsGoogleIntegration }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/settings/exchangeIntegration', component: AsyncSettingsExchangeIntegration }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/settings/room/create/:email', component: AsyncCreateRoom }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/settings/room/update/:email', component: AsyncUpdateRoom }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/term', component: AsyncTerm }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/editterm', component: AsyncEditTerm }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/regisseat/create/:id', component: AsyncCreateRegisterSeat }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/regisseat/update/:id', component: AsyncUpdateRegisterSeat }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/registerseat/disable/update/:id', component: AsyncDisableSeatUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/registerseat/disable/create', component: AsyncDisableSeatCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/registerseat/disable', component: AsyncDisableSeat }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/registerseat', component: AsyncRegisterSeat }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/faq', component: AsyncFaq }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/editfaq', component: AsyncEditFaq }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/contact', component: AsyncContactUs }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/editcontact', component: AsyncEditContactUs }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/setting', component: AsyncSetting }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/changesetting', component: AsyncChangeSetting }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/o365', component: AsyncListRoomsO365 }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/core/qrcode/:email', component: AsyncRoomQRCode }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/core', component: AsyncListRoomsCore }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/subscribe', component: AsyncListRoomsSubscribe }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/create', component: AsyncCreateRoomNew }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/update/:email', component: AsyncUpdateRoomNew }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/view/:email', component: AsyncViewRoomCore }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/o365', component: AsyncListUsersO365 }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/ad', component: AsyncListUsersAD }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/core', component: AsyncListUsersCore }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/create', component: AsyncCreateUser }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/update/:id', component: AsyncUpdateUser }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/view/:id', component: AsyncViewUserCore }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/group/list', component: AsyncListUserGroup }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/group/create', component: AsyncCreateUserGroup }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/group/update/:id', component: AsyncUpdateUserGroup }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/group/view/:id', component: AsyncViewUserGroup }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/profile/list', component: AsyncListProfile }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/profile/create', component: AsyncCreateProfile }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/profile/update/:id', component: AsyncUpdateProfile }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/profile/view/:id', component: AsyncViewProfile }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/amenity/create', component: AsyncAmenityCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/amenity/update/:id', component: AsyncAmenityUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/amenity/view/:id', component: AsyncViewAmenity }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/amenity', component: AsyncAmenity }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/building/create', component: AsyncBuildingCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/building/update/:id', component: AsyncBuildingUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/building/view/:id', component: AsyncViewBuilding }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/building', component: AsyncBuilding }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/background/create', component: AsyncBackgroundCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/background/update/:id', component: AsyncBackgroundUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/background/view/:id', component: AsyncViewBackground }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/background', component: AsyncBackground }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/floor/create', component: AsyncFloorCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/floor/update/:id', component: AsyncFloorUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/floor/view/:id', component: AsyncViewFloor }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/floor', component: AsyncFloor }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/zone/create', component: AsyncZoneCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/zone/update/:id', component: AsyncZoneUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/zone/view/:id', component: AsyncViewZone }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/zone', component: AsyncZone }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbsCategory/update/:id', component: AsyncUpdateFbsCategory }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbsCategory/create', component: AsyncCreateFbsCategory }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbsCategory', component: AsyncFbsCategory }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbs/create', component: AsyncFbsCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbs/update/:id', component: AsyncFbsUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbs/view/:id', component: AsyncViewFbs }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbs', component: AsyncFbs }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/settings', component: AsyncSettings }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/list', component: AsyncSettingsRoom }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/logino365', component: AsyncLoginO365 }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/authorize', component: AsyncAuthorizeO365 }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/checkroom/:email', component: AsyncCheckRoomInCore }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/userInfo', component: AsyncUserInfo }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/changepassword/:id', component: AsyncUserChangePassword }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/core/myroom', component: AsyncRoomInCore }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/overview/:type/:range', component: AsyncReportOverviewDetail }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/user/:id', component: AsyncReportUserDetail }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/room/:email', component: AsyncReportRoomDetail }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/statussummary', component: AsyncReportSummary }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/overview', component: AsyncReportOverview }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/byroom', component: AsyncReportByRoom }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/byuser', component: AsyncReportByUser }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/roomreport', component: AsyncRoomReportNew }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/userreport', component: AsyncUserReport }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/usersummary', component: AsyncUserSummary }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/roomsummary', component: AsyncRoomSummary }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/setting/user/list', component: AsyncUserList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/setting/user/add', component: AsyncUserAdd }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/setting/user/edit/:id', component: AsyncUserEdit }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/setting/user/changepass/:id', component: AsyncUserchangePass }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/iot/update/:id', component: AsyncIotUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/iot', component: AsyncIot }),
		react_default.a.createElement(routePermission.PrivateRoute, { component: AsyncNotFound })
	);
});
// CONCATENATED MODULE: ./src/features/ui/components/Footer.js


// import { Link } from 'react-router-dom'

/* harmony default export */ var Footer = (function () {
    return (
        // <div>
        //     <Segment
        //         style={{ margin: '5em 0em 0em', padding: '5em 0em',backgroundColor:"#333", color:'#ccc' }}
        //         vertical
        //         >
        //         <Container textAlign='center'>
        //             <Grid columns={2} divided stackable inverted>
        //                 <Grid.Row>
        //                     <Grid.Column>
        //                         <Image
        //                             centered
        //                             size='small'
        //                             src='/assets/images/logo.png'
        //                         />
        //                         <p>
        //                             <a href="http://www.roomminister.com/">www.roomminister.com</a>
        //                         </p>

        //                         <p>
        //                             MEETING ROOM BOOKING SYSTEM
        //                         </p>

        //                         <p>an intelligent software that help you to easily coordinate the people, spaces, and things in your office.</p>
        //                     </Grid.Column>                                 
        //                     <Grid.Column>
        //                         <Image
        //                             centered
        //                            
        //                             src='/assets/images/logo-bainisys.png'
        //                         />
        //                         <p>
        //                             <a href="http://www.bainisys.com">www.bainisys.com</a>
        //                         </p>
        //                         <p>YOUR BUSINESS PARTNER</p>
        //                         <p>The consulting firm in Thailand that provides a variety of IT service.</p>
        //                     </Grid.Column>
        //                 </Grid.Row>
        //             </Grid>
        //             <Divider inverted section />
        //             {/* <Image
        //                 centered
        //                 size='small'
        //                 src='/assets/images/logo.png'
        //             /> */}
        //             {/* <List horizontal inverted divided link>
        //                 <List.Item as='a' href='#'>Site Map</List.Item>
        //                 <List.Item as='a' href='#'>Contact Us</List.Item>
        //                 <List.Item as='a' href='#'>Terms and Conditions</List.Item>
        //                 <List.Item as='a' href='#'>Privacy Policy</List.Item>
        //             </List> */}
        //         </Container>
        //     </Segment>
        // </div>
        react_default.a.createElement(
            dist_es["q" /* Menu */],
            { secondary: true, fixed: 'bottom', style: { height: '55px' } },
            react_default.a.createElement(
                dist_es["i" /* Grid */],
                { style: { margin: '1em 0em 0em', padding: '1em 0em', backgroundColor: "#333", color: '#ccc', width: '100%', textAlign: 'center' } },
                react_default.a.createElement(
                    dist_es["i" /* Grid */].Row,
                    null,
                    react_default.a.createElement(dist_es["i" /* Grid */].Column, { width: 8 }),
                    react_default.a.createElement(dist_es["i" /* Grid */].Column, { width: 8 })
                )
            )
        )
    );
});
// CONCATENATED MODULE: ./src/features/ui/components/App.js


// import Breadcrumb from './Breadcrumb'




/* harmony default export */ var App = (function () {
    return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(components_Header, null),
        react_default.a.createElement(
            dist_es["d" /* Container */],
            { style: { minHeight: '219px', marginBottom: '5rem' } },
            react_default.a.createElement(Routes, null)
        ),
        react_default.a.createElement(Footer, null)
    );
});
// CONCATENATED MODULE: ./src/features/ui/components/Root.prod.js








var store = configureStore_default()();

/* harmony default export */ var Root_prod = __webpack_exports__["default"] = (function () {
	return react_default.a.createElement(
		react_redux_es["Provider"],
		{ store: store },
		react_default.a.createElement(
			'div',
			null,
			react_default.a.createElement(
				es["a" /* BrowserRouter */],
				null,
				react_default.a.createElement(App, null)
			),
			react_default.a.createElement(ErrorMessageDialog, null),
			react_default.a.createElement(Loading, null)
		)
	);
});

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(520);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 520:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(90);

// EXTERNAL MODULE: ./node_modules/redux-thunk/lib/index.js
var lib = __webpack_require__(521);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/middlewares/index.js + 3 modules
var src_middlewares = __webpack_require__(221);

// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js + 225 modules
var redux_form_es = __webpack_require__(484);

// EXTERNAL MODULE: ./node_modules/reapop/lib/index.js
var reapop_lib = __webpack_require__(640);
var reapop_lib_default = /*#__PURE__*/__webpack_require__.n(reapop_lib);

// EXTERNAL MODULE: ./src/types.js
var types = __webpack_require__(17);

// EXTERNAL MODULE: ./src/lib/index.js + 5 modules
var src_lib = __webpack_require__(70);

// CONCATENATED MODULE: ./src/features/auth/reducer.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var allToken = Object(src_lib["f" /* getAllToken */])();
var bsrsToken = Object(src_lib["g" /* getBSRSToken */])();
var serviceToken = Object(src_lib["n" /* getServiceToken */])();

var reducer_initialState = {
  token: allToken,
  bsrsToken: bsrsToken,
  user: Object(src_lib["q" /* getUserInfo */])(allToken.access_token),
  serviceToken: serviceToken
};

/* harmony default export */ var reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducer_initialState;
  var action = arguments[1];

  switch (action.type) {
    case types["_313" /* O365_REGISTER_SUCCESS */]:
      {
        return _extends({}, state, {
          token: _extends({}, action.payload.token),
          user: Object(src_lib["q" /* getUserInfo */])(action.payload.token.access_token)
        });
      }
    case types["c" /* BSRS_LOGIN_SUCCESS */]:
      {
        return _extends({}, state, {
          bsrsToken: action.payload.bsrsToken
        });
      }
    case types["f" /* BSRS_SERVICE_TOKEN_SUCCESS */]:
      {
        return _extends({}, state, {
          bsrsToken: action.payload.bsrsToken,
          serviceToken: action.payload.serviceToken
        });
      }
    case types["_274" /* LOGOUT */]:
      return _extends({}, state, {
        bsrsToken: undefined
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./src/features/ui/reducer.js
var reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var ui_reducer_initialState = {
    hasError: false,
    isLoading: false,
    error: null
};

/* harmony default export */ var ui_reducer = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ui_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
        case types["_210" /* CORE_LOAD_USER_INFO_REQUEST */]:
        case types["_312" /* O365_REGISTER_REQUEST */]:
        case types["_24" /* CORE_DELETE_ROOM_REQUEST */]:
        case types["_294" /* O365_LOAD_EVENTS_REQUEST */]:
        case types["_297" /* O365_LOAD_EVENT_REQUEST */]:
        case types["_309" /* O365_LOAD_USER_INFO_REQUEST */]:
        case types["_279" /* O365_CREATE_EVENT_REQUEST */]:
        case types["_288" /* O365_DELETE_EVENT_REQUEST */]:
        case types["_276" /* O365_ACCEPT_EVENT_REQUEST */]:
        case types["_315" /* O365_TENTATIVE_EVENT_REQUEST */]:
        case types["_285" /* O365_DECLINE_EVENT_REQUEST */]:
        case types["_134" /* CORE_LOAD_ORDERS_REQUEST */]:
        case types["_39" /* CORE_FIND_ROOM_REQUEST */]:
        case types["_212" /* CORE_LOAD_USER_REQUEST */]:
        case types["_266" /* CORE_UPDATE_USER_REQUEST */]:
        case types["_30" /* CORE_DELETE_USER_REQUEST */]:
        case types["_206" /* CORE_LOAD_USERS_REQUEST */]:
        case types["_158" /* CORE_LOAD_ROOMS_REQUEST */]:
        case types["_257" /* CORE_UPDATE_ROOM_REQUEST */]:
        case types["_173" /* CORE_LOAD_SETTING_INFO_REQUEST */]:
        case types["_179" /* CORE_LOAD_TERM_REQUEST */]:
        case types["_260" /* CORE_UPDATE_TERM_REQUEST */]:
        case types["_113" /* CORE_LOAD_FAQ_REQUEST */]:
        case types["_107" /* CORE_LOAD_CONTACT_US_REQUEST */]:
        case types["_140" /* CORE_LOAD_REPORTROOMSTATUS_REQUEST */]:
        case types["_149" /* CORE_LOAD_ROOMDETAIL_REQUEST */]:
        case types["b" /* BSRS_LOGIN_REQUEST */]:
        case types["_89" /* CORE_LOAD_ALL_CATEGORY_REQUEST */]:
        case types["_116" /* CORE_LOAD_FBSINFO_REQUEST */]:
        case types["_12" /* CORE_DELETE_FBS_REQUEST */]:
        case types["_131" /* CORE_LOAD_LOCATIONS_REQUEST */]:
        case types["_98" /* CORE_LOAD_AMENITYINFO_REQUEST */]:
        case types["_80" /* CORE_LOAD_ALLFLOOR_REQUEST */]:
        case types["_119" /* CORE_LOAD_FLOORINFO_REQUEST */]:
        case types["_71" /* CORE_LOAD_ALLBUILDING_REQUEST */]:
        case types["_104" /* CORE_LOAD_BUILDINGINFO_REQUEST */]:
        case types["_68" /* CORE_LOAD_ALLBACKGROUND_REQUEST */]:
        case types["_3" /* CORE_DELETE_BACKGROUND_REQUEST */]:
        case types["_101" /* CORE_LOAD_BACKGROUNDINFO_REQUEST */]:
        case types["_221" /* CORE_UPDATE_BACKGROUNDINFO_REQUEST */]:
        case types["t" /* CORE_CREATE_BACKGROUND_REQUEST */]:
        case types["_6" /* CORE_DELETE_BUILDING_REQUEST */]:
        case types["_224" /* CORE_UPDATE_BUILDINGINFO_REQUEST */]:
        case types["w" /* CORE_CREATE_BUILDING_REQUEST */]:
        case types["_18" /* CORE_DELETE_FLOOR_REQUEST */]:
        case types["_245" /* CORE_UPDATE_FLOORINFO_REQUEST */]:
        case types["I" /* CORE_CREATE_FLOOR_REQUEST */]:
        case types["_86" /* CORE_LOAD_ALLZONE_REQUEST */]:
        case types["_33" /* CORE_DELETE_ZONE_REQUEST */]:
        case types["_215" /* CORE_LOAD_ZONEINFO_REQUEST */]:
        case types["_269" /* CORE_UPDATE_ZONEINFO_REQUEST */]:
        case types["X" /* CORE_CREATE_ZONE_REQUEST */]:
        case types["_242" /* CORE_UPDATE_FB_CATEGORY_REQUEST */]:
        case types["_42" /* CORE_GET_CATEGORY_INFO_REQUEST */]:
        case types["F" /* CORE_CREATE_FB_CATEGORY_REQUEST */]:
        case types["_15" /* CORE_DELETE_FB_CATEGORY_REQUEST */]:
        case types["O" /* CORE_CREATE_ROOM_REQUEST */]:
        case types["_303" /* O365_LOAD_ROOMS_REQUEST */]:
        case types["_160" /* CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST */]:
        case types["_291" /* O365_DELETE_ROOM_SUBSCRIBE_REQUEST */]:
        case types["_282" /* O365_CREATE_ROOM_SUBSCRIBE_REQUEST */]:
        case types["_77" /* CORE_LOAD_ALLFBS_REQUEST */]:
        case types["_239" /* CORE_UPDATE_FBSINFO_REQUEST */]:
        case types["C" /* CORE_CREATE_FBS_REQUEST */]:
        case types["_191" /* CORE_LOAD_USERGROUPS_REQUEST */]:
        case types["_125" /* CORE_LOAD_LIST_USERGROUPS_REQUEST */]:
        case types["_194" /* CORE_LOAD_USERGROUP_REQUEST */]:
        case types["R" /* CORE_CREATE_USERGROUP_REQUEST */]:
        case types["_263" /* CORE_UPDATE_USERGROUP_REQUEST */]:
        case types["_27" /* CORE_DELETE_USERGROUP_REQUEST */]:
        case types["k" /* CORE_CHANGE_SETTING_REQUEST */]:
        case types["n" /* CORE_CHECK_AD_REQUEST */]:
        case types["U" /* CORE_CREATE_USER_REQUEST */]:
        case types["h" /* CORE_CHANGE_PASSWORD_REQUEST */]:
        case types["_306" /* O365_LOAD_USERS_REQUEST */]:
        case types["_95" /* CORE_LOAD_ALL_USERSAD_REQUEST */]:
        case types["_92" /* CORE_LOAD_ALL_PROFILE_REQUEST */]:
        case types["L" /* CORE_CREATE_PROFILE_REQUEST */]:
        case types["_21" /* CORE_DELETE_PROFILE_REQUEST */]:
        case types["_137" /* CORE_LOAD_PROFILE_INFO_REQUEST */]:
        case types["_254" /* CORE_UPDATE_PROFILE_REQUEST */]:
        case types["_230" /* CORE_UPDATE_DEFAULTBACKGROUND_REQUEST */]:
        case types["_65" /* CORE_LOAD_ALLAMENITY_REQUEST */]:
        case types["_0" /* CORE_DELETE_AMENITY_REQUEST */]:
        case types["_218" /* CORE_UPDATE_AMENITYINFO_REQUEST */]:
        case types["q" /* CORE_CREATE_AMENITY_REQUEST */]:
        case types["_143" /* CORE_LOAD_REPORTSUMMARY_REQUEST */]:
        case types["_170" /* CORE_LOAD_SEATINFO_REQUEST */]:
        case types["_9" /* CORE_DELETE_DISABLESEATINFO_REQUEST */]:
            return reducer__extends({}, state, {
                isLoading: true,
                hasError: false,
                error: null
            });
        case types["_211" /* CORE_LOAD_USER_INFO_SUCCESS */]:
        case types["_313" /* O365_REGISTER_SUCCESS */]:
        case types["_295" /* O365_LOAD_EVENTS_SUCCESS */]:
        case types["_298" /* O365_LOAD_EVENT_SUCCESS */]:
        case types["_310" /* O365_LOAD_USER_INFO_SUCCESS */]:
        case types["_280" /* O365_CREATE_EVENT_SUCCESS */]:
        case types["_289" /* O365_DELETE_EVENT_SUCCESS */]:
        case types["_277" /* O365_ACCEPT_EVENT_SUCCESS */]:
        case types["_316" /* O365_TENTATIVE_EVENT_SUCCESS */]:
        case types["_286" /* O365_DECLINE_EVENT_SUCCESS */]:
        case types["_135" /* CORE_LOAD_ORDERS_SUCCESS */]:
        case types["_40" /* CORE_FIND_ROOM_SUCCESS */]:
        case types["_25" /* CORE_DELETE_ROOM_SUCCESS */]:
        case types["_213" /* CORE_LOAD_USER_SUCCESS */]:
        case types["_267" /* CORE_UPDATE_USER_SUCCESS */]:
        case types["_31" /* CORE_DELETE_USER_SUCCESS */]:
        case types["_207" /* CORE_LOAD_USERS_SUCCESS */]:
        case types["_162" /* CORE_LOAD_ROOMS_SUCCESS */]:
        case types["_258" /* CORE_UPDATE_ROOM_SUCCESS */]:
        case types["_174" /* CORE_LOAD_SETTING_INFO_SUCCESS */]:
        case types["_180" /* CORE_LOAD_TERM_SUCCESS */]:
        case types["_261" /* CORE_UPDATE_TERM_SUCCESS */]:
        case types["_114" /* CORE_LOAD_FAQ_SUCCESS */]:
        case types["_108" /* CORE_LOAD_CONTACT_US_SUCCESS */]:
        case types["_141" /* CORE_LOAD_REPORTROOMSTATUS_SUCCESS */]:
        case types["_150" /* CORE_LOAD_ROOMDETAIL_SUCCESS */]:
        case types["_90" /* CORE_LOAD_ALL_CATEGORY_SUCCESS */]:
        case types["_117" /* CORE_LOAD_FBSINFO_SUCCESS */]:
        case types["_13" /* CORE_DELETE_FBS_SUCCESS */]:
        case types["_132" /* CORE_LOAD_LOCATIONS_SUCCESS */]:
        case types["_99" /* CORE_LOAD_AMENITYINFO_SUCCESS */]:
        case types["_81" /* CORE_LOAD_ALLFLOOR_SUCCESS */]:
        case types["_120" /* CORE_LOAD_FLOORINFO_SUCCESS */]:
        case types["_72" /* CORE_LOAD_ALLBUILDING_SUCCESS */]:
        case types["_105" /* CORE_LOAD_BUILDINGINFO_SUCCESS */]:
        case types["_69" /* CORE_LOAD_ALLBACKGROUND_SUCCESS */]:
        case types["_4" /* CORE_DELETE_BACKGROUND_SUCCESS */]:
        case types["_102" /* CORE_LOAD_BACKGROUNDINFO_SUCCESS */]:
        case types["_222" /* CORE_UPDATE_BACKGROUNDINFO_SUCCESS */]:
        case types["u" /* CORE_CREATE_BACKGROUND_SUCCESS */]:
        case types["_7" /* CORE_DELETE_BUILDING_SUCCESS */]:
        case types["_225" /* CORE_UPDATE_BUILDINGINFO_SUCCESS */]:
        case types["x" /* CORE_CREATE_BUILDING_SUCCESS */]:
        case types["_19" /* CORE_DELETE_FLOOR_SUCCESS */]:
        case types["_246" /* CORE_UPDATE_FLOORINFO_SUCCESS */]:
        case types["J" /* CORE_CREATE_FLOOR_SUCCESS */]:
        case types["_87" /* CORE_LOAD_ALLZONE_SUCCESS */]:
        case types["_34" /* CORE_DELETE_ZONE_SUCCESS */]:
        case types["_216" /* CORE_LOAD_ZONEINFO_SUCCESS */]:
        case types["_270" /* CORE_UPDATE_ZONEINFO_SUCCESS */]:
        case types["Y" /* CORE_CREATE_ZONE_SUCCESS */]:
        case types["_243" /* CORE_UPDATE_FB_CATEGORY_SUCCESS */]:
        case types["_43" /* CORE_GET_CATEGORY_INFO_SUCCESS */]:
        case types["G" /* CORE_CREATE_FB_CATEGORY_SUCCESS */]:
        case types["_16" /* CORE_DELETE_FB_CATEGORY_SUCCESS */]:
        case types["P" /* CORE_CREATE_ROOM_SUCCESS */]:
        case types["_304" /* O365_LOAD_ROOMS_SUCCESS */]:
        case types["_161" /* CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS */]:
        case types["_292" /* O365_DELETE_ROOM_SUBSCRIBE_SUCCESS */]:
        case types["_283" /* O365_CREATE_ROOM_SUBSCRIBE_SUCCESS */]:
        case types["_78" /* CORE_LOAD_ALLFBS_SUCCESS */]:
        case types["_240" /* CORE_UPDATE_FBSINFO_SUCCESS */]:
        case types["D" /* CORE_CREATE_FBS_SUCCESS */]:
        case types["_192" /* CORE_LOAD_USERGROUPS_SUCCESS */]:
        case types["_126" /* CORE_LOAD_LIST_USERGROUPS_SUCCESS */]:
        case types["_195" /* CORE_LOAD_USERGROUP_SUCCESS */]:
        case types["S" /* CORE_CREATE_USERGROUP_SUCCESS */]:
        case types["_264" /* CORE_UPDATE_USERGROUP_SUCCESS */]:
        case types["_28" /* CORE_DELETE_USERGROUP_SUCCESS */]:
        case types["l" /* CORE_CHANGE_SETTING_SUCCESS */]:
        case types["o" /* CORE_CHECK_AD_SUCCESS */]:
        case types["V" /* CORE_CREATE_USER_SUCCESS */]:
        case types["i" /* CORE_CHANGE_PASSWORD_SUCCESS */]:
        case types["_307" /* O365_LOAD_USERS_SUCCESS */]:
        case types["_96" /* CORE_LOAD_ALL_USERSAD_SUCCESS */]:
        case types["_93" /* CORE_LOAD_ALL_PROFILE_SUCCESS */]:
        case types["M" /* CORE_CREATE_PROFILE_SUCCESS */]:
        case types["_22" /* CORE_DELETE_PROFILE_SUCCESS */]:
        case types["_138" /* CORE_LOAD_PROFILE_INFO_SUCCESS */]:
        case types["_255" /* CORE_UPDATE_PROFILE_SUCCESS */]:
        case types["_231" /* CORE_UPDATE_DEFAULTBACKGROUND_SUCCESS */]:
        case types["_66" /* CORE_LOAD_ALLAMENITY_SUCCESS */]:
        case types["_1" /* CORE_DELETE_AMENITY_SUCCESS */]:
        case types["_219" /* CORE_UPDATE_AMENITYINFO_SUCCESS */]:
        case types["r" /* CORE_CREATE_AMENITY_SUCCESS */]:
        case types["_144" /* CORE_LOAD_REPORTSUMMARY_SUCCESS */]:
        case types["_171" /* CORE_LOAD_SEATINFO_SUCCESS */]:
        case types["_10" /* CORE_DELETE_DISABLESEATINFO_SUCCESS */]:
            return reducer__extends({}, state, {
                isLoading: false
                // hasError: false,
                // error: null,
            });
        case types["_209" /* CORE_LOAD_USER_INFO_FAILURE */]:
        case types["_308" /* O365_LOAD_USER_INFO_FAILURE */]:
        case types["_296" /* O365_LOAD_EVENT_FAILURE */]:
        case types["_293" /* O365_LOAD_EVENTS_FAILURE */]:
        case types["_278" /* O365_CREATE_EVENT_FAILURE */]:
        case types["_287" /* O365_DELETE_EVENT_FAILURE */]:
        case types["_275" /* O365_ACCEPT_EVENT_FAILURE */]:
        case types["_314" /* O365_TENTATIVE_EVENT_FAILURE */]:
        case types["_284" /* O365_DECLINE_EVENT_FAILURE */]:
        case types["_133" /* CORE_LOAD_ORDERS_FAILURE */]:
        case types["_38" /* CORE_FIND_ROOM_FAILURE */]:
        case types["_23" /* CORE_DELETE_ROOM_FAILURE */]:
        case types["_208" /* CORE_LOAD_USER_FAILURE */]:
        case types["_265" /* CORE_UPDATE_USER_FAILURE */]:
        case types["_29" /* CORE_DELETE_USER_FAILURE */]:
        case types["_205" /* CORE_LOAD_USERS_FAILURE */]:
        case types["_157" /* CORE_LOAD_ROOMS_FAILURE */]:
        case types["_256" /* CORE_UPDATE_ROOM_FAILURE */]:
        case types["_172" /* CORE_LOAD_SETTING_INFO_FAILURE */]:
        case types["_178" /* CORE_LOAD_TERM_FAILURE */]:
        case types["_259" /* CORE_UPDATE_TERM_FAILURE */]:
        case types["_112" /* CORE_LOAD_FAQ_FAILURE */]:
        case types["_106" /* CORE_LOAD_CONTACT_US_FAILURE */]:
        case types["_139" /* CORE_LOAD_REPORTROOMSTATUS_FAILURE */]:
        case types["_148" /* CORE_LOAD_ROOMDETAIL_FAILURE */]:
        case types["_106" /* CORE_LOAD_CONTACT_US_FAILURE */]:
        case types["a" /* BSRS_LOGIN_FAILURE */]:
        case types["_88" /* CORE_LOAD_ALL_CATEGORY_FAILURE */]:
        case types["_115" /* CORE_LOAD_FBSINFO_FAILURE */]:
        case types["_11" /* CORE_DELETE_FBS_FAILURE */]:
        case types["_127" /* CORE_LOAD_LOCATIONS_FAILURE */]:
        case types["_97" /* CORE_LOAD_AMENITYINFO_FAILURE */]:
        case types["_79" /* CORE_LOAD_ALLFLOOR_FAILURE */]:
        case types["_118" /* CORE_LOAD_FLOORINFO_FAILURE */]:
        case types["_70" /* CORE_LOAD_ALLBUILDING_FAILURE */]:
        case types["_103" /* CORE_LOAD_BUILDINGINFO_FAILURE */]:
        case types["_67" /* CORE_LOAD_ALLBACKGROUND_FAILURE */]:
        case types["_2" /* CORE_DELETE_BACKGROUND_FAILURE */]:
        case types["_100" /* CORE_LOAD_BACKGROUNDINFO_FAILURE */]:
        case types["_220" /* CORE_UPDATE_BACKGROUNDINFO_FAILURE */]:
        case types["s" /* CORE_CREATE_BACKGROUND_FAILURE */]:
        case types["_5" /* CORE_DELETE_BUILDING_FAILURE */]:
        case types["_223" /* CORE_UPDATE_BUILDINGINFO_FAILURE */]:
        case types["v" /* CORE_CREATE_BUILDING_FAILURE */]:
        case types["_17" /* CORE_DELETE_FLOOR_FAILURE */]:
        case types["_244" /* CORE_UPDATE_FLOORINFO_FAILURE */]:
        case types["H" /* CORE_CREATE_FLOOR_FAILURE */]:
        case types["_85" /* CORE_LOAD_ALLZONE_FAILURE */]:
        case types["_32" /* CORE_DELETE_ZONE_FAILURE */]:
        case types["_214" /* CORE_LOAD_ZONEINFO_FAILURE */]:
        case types["_268" /* CORE_UPDATE_ZONEINFO_FAILURE */]:
        case types["W" /* CORE_CREATE_ZONE_FAILURE */]:
        case types["_241" /* CORE_UPDATE_FB_CATEGORY_FAILURE */]:
        case types["_41" /* CORE_GET_CATEGORY_INFO_FAILURE */]:
        case types["E" /* CORE_CREATE_FB_CATEGORY_FAILURE */]:
        case types["_14" /* CORE_DELETE_FB_CATEGORY_FAILURE */]:
        case types["N" /* CORE_CREATE_ROOM_FAILURE */]:
        case types["_302" /* O365_LOAD_ROOMS_FAILURE */]:
        case types["_159" /* CORE_LOAD_ROOMS_SUBSCRIBE_FAILURE */]:
        case types["_290" /* O365_DELETE_ROOM_SUBSCRIBE_FAILURE */]:
        case types["_281" /* O365_CREATE_ROOM_SUBSCRIBE_FAILURE */]:
        case types["_76" /* CORE_LOAD_ALLFBS_FAILURE */]:
        case types["_238" /* CORE_UPDATE_FBSINFO_FAILURE */]:
        case types["B" /* CORE_CREATE_FBS_FAILURE */]:
        case types["_190" /* CORE_LOAD_USERGROUPS_FAILURE */]:
        case types["_124" /* CORE_LOAD_LIST_USERGROUPS_FAILURE */]:
        case types["_193" /* CORE_LOAD_USERGROUP_FAILURE */]:
        case types["Q" /* CORE_CREATE_USERGROUP_FAILURE */]:
        case types["_262" /* CORE_UPDATE_USERGROUP_FAILURE */]:
        case types["_26" /* CORE_DELETE_USERGROUP_FAILURE */]:
        case types["j" /* CORE_CHANGE_SETTING_FAILURE */]:
        case types["m" /* CORE_CHECK_AD_FAILURE */]:
        case types["T" /* CORE_CREATE_USER_FAILURE */]:
        case types["g" /* CORE_CHANGE_PASSWORD_FAILURE */]:
        case types["_305" /* O365_LOAD_USERS_FAILURE */]:
        case types["_94" /* CORE_LOAD_ALL_USERSAD_FAILURE */]:
        case types["_91" /* CORE_LOAD_ALL_PROFILE_FAILURE */]:
        case types["K" /* CORE_CREATE_PROFILE_FAILURE */]:
        case types["_20" /* CORE_DELETE_PROFILE_FAILURE */]:
        case types["_136" /* CORE_LOAD_PROFILE_INFO_FAILURE */]:
        case types["_253" /* CORE_UPDATE_PROFILE_FAILURE */]:
        case types["_229" /* CORE_UPDATE_DEFAULTBACKGROUND_FAILURE */]:
        case types["_64" /* CORE_LOAD_ALLAMENITY_FAILURE */]:
        case types["Z" /* CORE_DELETE_AMENITY_FAILURE */]:
        case types["_217" /* CORE_UPDATE_AMENITYINFO_FAILURE */]:
        case types["p" /* CORE_CREATE_AMENITY_FAILURE */]:
        case types["_142" /* CORE_LOAD_REPORTSUMMARY_FAILURE */]:
        case types["_169" /* CORE_LOAD_SEATINFO_FAILURE */]:
        case types["_8" /* CORE_DELETE_DISABLESEATINFO_FAILURE */]:
            return reducer__extends({}, state, {
                isLoading: false,
                hasError: true,
                error: action.payload.data
            });
        case types["_320" /* SET_ERROR */]:
            return reducer__extends({}, state, {
                hasError: action.hasError,
                error: action.error
            });
        default:
            return state;
    }
});
// CONCATENATED MODULE: ./src/features/settings/integration/reducer.js
var integration_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var noMessage = {
    success: "",
    error: ""
};
var _initialState = integration_reducer__extends({
    step: 1,
    o365: {
        tenant_id: "",
        client_id: ""
    }
}, noMessage);

/* harmony default export */ var integration_reducer = ({
    initialState: function initialState() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState;
        var action = arguments[1];

        switch (action.type) {

            case types["_56" /* CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID */]:
                {
                    return _initialState;
                }

            case types["_57" /* CORE_INTEGRATION_O365_GO_ADMIN_CONSENT */]:
                {
                    var _action$payload = action.payload,
                        step = _action$payload.step,
                        client_id = _action$payload.client_id;

                    return integration_reducer__extends({
                        step: step,
                        o365: integration_reducer__extends({}, state.o365, {
                            client_id: client_id
                        })
                    }, noMessage);
                }

            case types["_58" /* CORE_INTEGRATION_O365_GO_SAVE_DATA */]:
                {
                    var _action$payload2 = action.payload,
                        _step = _action$payload2.step,
                        _client_id = _action$payload2.client_id,
                        tenant_id = _action$payload2.tenant_id;

                    return integration_reducer__extends({
                        step: _step,
                        o365: {
                            tenant_id: tenant_id,
                            client_id: _client_id
                        }
                    }, noMessage);
                }

            case types["_53" /* CORE_INTEGRATION_O365_ADD_CLIENT_ID */]:
                {
                    var _action$payload3 = action.payload,
                        _step2 = _action$payload3.step,
                        _client_id2 = _action$payload3.client_id;

                    return integration_reducer__extends({
                        step: _step2,
                        o365: integration_reducer__extends({}, state.o365, {
                            client_id: _client_id2
                        })
                    }, noMessage);
                }

            case types["_54" /* CORE_INTEGRATION_O365_ADMIN_CONSENT */]:
                {
                    var _action$payload4 = action.payload,
                        _step3 = _action$payload4.step,
                        _tenant_id = _action$payload4.tenant_id;

                    return integration_reducer__extends({
                        step: _step3,
                        o365: integration_reducer__extends({}, state.o365, {
                            tenant_id: _tenant_id
                        })
                    }, noMessage);
                }
            case types["_60" /* CORE_INTEGRATION_O365_SUCCESS */]:
                return integration_reducer__extends({}, _initialState, {
                    success: "Connect Successfully"
                });

            case types["_55" /* CORE_INTEGRATION_O365_FAILURE */]:
                return integration_reducer__extends({}, _initialState, {
                    step: 3,
                    success: "",
                    error: "Connect failed. Please check your data"
                });
            default:
                return state;
        }
    },
    ini: function ini() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_48" /* CORE_GET_INTEGRATION_REQUEST */]:
                return _initialState;

            case types["_49" /* CORE_GET_INTEGRATION_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    integrationInfo: function integrationInfo() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_46" /* CORE_GET_INTEGRATION_INFO_REQUEST */]:
                return _initialState;

            case types["_47" /* CORE_GET_INTEGRATION_INFO_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/rooms/reducer.js


var rooms_reducer_initialState = [];
/* harmony default export */ var rooms_reducer = ({
  roomsO365: function roomsO365() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_303" /* O365_LOAD_ROOMS_REQUEST */]:
        return rooms_reducer_initialState;
      case types["_304" /* O365_LOAD_ROOMS_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  },
  roomsCore: function roomsCore() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_158" /* CORE_LOAD_ROOMS_REQUEST */]:
        return rooms_reducer_initialState;
      case types["_162" /* CORE_LOAD_ROOMS_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  },
  roomCore: function roomCore() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_39" /* CORE_FIND_ROOM_REQUEST */]:
        return {};
      case types["_40" /* CORE_FIND_ROOM_SUCCESS */]:
        if (action.payload) return action.payload;else return {};
      default:
        return state;
    }
  },
  roomsSubscribe: function roomsSubscribe() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_160" /* CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST */]:
        return rooms_reducer_initialState;
      case types["_161" /* CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/report/reducer.js


var report_reducer_initialState = [];
/* harmony default export */ var report_reducer = ({
  coreRoom: function coreRoom() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_129" /* CORE_LOAD_LOCATIONS_REPORT_REQUEST */]:
        return report_reducer_initialState;

      case types["_130" /* CORE_LOAD_LOCATIONS_REPORT_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var locations = [];
          for (var i = 0; i < payload.length; i++) {
            locations.push({
              value: payload[i].email,
              key: i,
              text: payload[i].name,
              name: payload[i].name
            });
          }
          return locations;
        } else return [{}];

      default:
        return state;
    }
  },
  statusSum: function statusSum() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_143" /* CORE_LOAD_REPORTSUMMARY_REQUEST */]:
        return state;

      case types["_144" /* CORE_LOAD_REPORTSUMMARY_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  roomReports: function roomReports() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_146" /* CORE_LOAD_REPORT_REQUEST */]:
        return report_reducer_initialState;
      case types["_147" /* CORE_LOAD_REPORT_SUCCESS */]:
        var data = [];
        if (action.payload !== '') {
          var actionlog = action.payload;
          actionlog.data.forEach(function (payload) {
            var createEvent = false;
            var updateEvent = false;
            var deleteEvent = false;
            var type = payload.meta.type;
            if (type === "CREATE_EVENT") createEvent = true;else if (type === "UPDATE_EVENT") updateEvent = true;else deleteEvent = true;
            data.push({
              startDateTimeThai: payload.meta.data.startDateTimeThai,
              endDateTimeThai: payload.meta.data.endDateTimeThai,
              organizerAddress: payload.meta.data.organizer.emailAddress.name,
              subject: payload.meta.data.subject,
              _id: payload._id,
              createEvent: createEvent,
              updateEvent: updateEvent,
              deleteEvent: deleteEvent,
              message: payload.meta.message,
              meetnow: payload.meta.meetnow ? true : false
            });
          });
          return data;
        }
        return action.payload;

      default:
        return state;
    }
  },
  userReport: function userReport() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_197" /* CORE_LOAD_USERREPORT_REQUEST */]:
        return report_reducer_initialState;

      case types["_198" /* CORE_LOAD_USERREPORT_SUCCESS */]:
        var payload = action.payload;
        var status = [];
        status.push({
          reportHeader: payload.reportHeader,
          data: payload.data
        });
        return status;

      default:
        return state;
    }
  },
  roomReport: function roomReport() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_152" /* CORE_LOAD_ROOMREPORT_REQUEST */]:
        return report_reducer_initialState;

      case types["_153" /* CORE_LOAD_ROOMREPORT_SUCCESS */]:
        var payload = action.payload;
        var status = [];
        status.push({
          reportHeader: payload.reportHeader,
          data: payload.data
        });
        return status;

      default:
        return state;
    }
  },
  userSum: function userSum() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_200" /* CORE_LOAD_USERSUMMARY_REQUEST */]:
        return report_reducer_initialState;

      case types["_201" /* CORE_LOAD_USERSUMMARY_SUCCESS */]:
        var payload = action.payload;
        var status = [];
        status.push({
          reportHeader: payload.reportHeader,
          data: payload.data,
          summary: payload.summary
        });
        return status;

      default:
        return state;
    }
  },
  roomSum: function roomSum() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_155" /* CORE_LOAD_ROOMSUMMARY_REQUEST */]:
        return report_reducer_initialState;

      case types["_156" /* CORE_LOAD_ROOMSUMMARY_SUCCESS */]:
        var payload = action.payload;
        var status = [];
        status.push({
          reportHeader: payload.reportHeader,
          data: payload.data,
          summary: payload.summary
        });
        return status;

      default:
        return state;
    }
  },
  userStatus: function userStatus() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_176" /* CORE_LOAD_STATUSUSER_REQUEST */]:
        return report_reducer_initialState;

      case types["_177" /* CORE_LOAD_STATUSUSER_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  userSummary: function userSummary() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_203" /* CORE_LOAD_USERSUM_REQUEST */]:
        return report_reducer_initialState;

      case types["_204" /* CORE_LOAD_USERSUM_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  roomsStatus: function roomsStatus() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_140" /* CORE_LOAD_REPORTROOMSTATUS_REQUEST */]:
        return report_reducer_initialState;

      case types["_141" /* CORE_LOAD_REPORTROOMSTATUS_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  roomTemp: function roomTemp() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_164" /* CORE_LOAD_ROOMTEMP_REQUEST */]:
        return report_reducer_initialState;

      case types["_165" /* CORE_LOAD_ROOMTEMP_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  topRoom: function topRoom() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_185" /* CORE_LOAD_TOPROOMRESERVE_REQUEST */]:
        return report_reducer_initialState;

      case types["_186" /* CORE_LOAD_TOPROOMRESERVE_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  topUser: function topUser() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_188" /* CORE_LOAD_TOPUSERRESERVE_REQUEST */]:
        return report_reducer_initialState;

      case types["_189" /* CORE_LOAD_TOPUSERRESERVE_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  roomDetail: function roomDetail() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_149" /* CORE_LOAD_ROOMDETAIL_REQUEST */]:
        return state;

      case types["_150" /* CORE_LOAD_ROOMDETAIL_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/user/reducer.js


var user_reducer_initialState = [];

/* harmony default export */ var user_reducer = ({
  users: function users() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_206" /* CORE_LOAD_USERS_REQUEST */]:
        return [];
      case types["_207" /* CORE_LOAD_USERS_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  usersO365: function usersO365() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_306" /* O365_LOAD_USERS_REQUEST */]:
        return [];
      case types["_307" /* O365_LOAD_USERS_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  usersAD: function usersAD() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_95" /* CORE_LOAD_ALL_USERSAD_REQUEST */]:
        return [];
      case types["_96" /* CORE_LOAD_ALL_USERSAD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  user: function user() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_210" /* CORE_LOAD_USER_INFO_REQUEST */]:
        return {};
      case types["_211" /* CORE_LOAD_USER_INFO_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/setting/reducer.js


var setting_reducer_initialState = [];

/* harmony default export */ var setting_reducer = ({
  setting: function setting() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_173" /* CORE_LOAD_SETTING_INFO_REQUEST */]:
        return state;
      case types["_174" /* CORE_LOAD_SETTING_INFO_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  AD: function AD() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["n" /* CORE_CHECK_AD_REQUEST */]:
        return {};
      case types["o" /* CORE_CHECK_AD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  timezone: function timezone() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_182" /* CORE_LOAD_TIMEZOZE_REQUEST */]:
        return [];
      case types["_183" /* CORE_LOAD_TIMEZOZE_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/settings/amenity/reducer.js


var amenity_reducer_initialState = [];
/* harmony default export */ var amenity_reducer = ({
  amenity: function amenity() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenity_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_65" /* CORE_LOAD_ALLAMENITY_REQUEST */]:
        return amenity_reducer_initialState;

      case types["_66" /* CORE_LOAD_ALLAMENITY_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  amenityInfo: function amenityInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenity_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_98" /* CORE_LOAD_AMENITYINFO_REQUEST */]:
        return amenity_reducer_initialState;

      case types["_99" /* CORE_LOAD_AMENITYINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/settings/term/reducer.js


var term_reducer_initialState = {};
/* harmony default export */ var term_reducer = ({
  term: function term() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : term_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_179" /* CORE_LOAD_TERM_REQUEST */]:
      case types["_260" /* CORE_UPDATE_TERM_REQUEST */]:
        return term_reducer_initialState;

      case types["_180" /* CORE_LOAD_TERM_SUCCESS */]:
      case types["_261" /* CORE_UPDATE_TERM_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/settings/faq/reducer.js


var faq_reducer_initialState = {};
/* harmony default export */ var faq_reducer = ({
  faq: function faq() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : faq_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_113" /* CORE_LOAD_FAQ_REQUEST */]:
      case types["_236" /* CORE_UPDATE_FAQ_REQUEST */]:
        return faq_reducer_initialState;

      case types["_114" /* CORE_LOAD_FAQ_SUCCESS */]:
      case types["_237" /* CORE_UPDATE_FAQ_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/settings/contact/reducer.js


var contact_reducer_initialState = {};
/* harmony default export */ var contact_reducer = ({
  contactus: function contactus() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : contact_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_107" /* CORE_LOAD_CONTACT_US_REQUEST */]:
      case types["_227" /* CORE_UPDATE_CONTACT_US_REQUEST */]:
        return contact_reducer_initialState;

      case types["_108" /* CORE_LOAD_CONTACT_US_SUCCESS */]:
      case types["_228" /* CORE_UPDATE_CONTACT_US_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/profile/reducer.js


var profile_reducer_initialState = [];
/* harmony default export */ var profile_reducer = ({
  profileList: function profileList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : profile_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_92" /* CORE_LOAD_ALL_PROFILE_REQUEST */]:
        return profile_reducer_initialState;
      case types["_93" /* CORE_LOAD_ALL_PROFILE_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  },
  profileInfo: function profileInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : profile_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_137" /* CORE_LOAD_PROFILE_INFO_REQUEST */]:
        return profile_reducer_initialState;
      case types["_138" /* CORE_LOAD_PROFILE_INFO_SUCCESS */]:
        if (action.payload) return action.payload;else return {};
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/usergroup/reducer.js


var usergroup_reducer_initialState = [];
/* harmony default export */ var usergroup_reducer = ({
  usergroups: function usergroups() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : usergroup_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_191" /* CORE_LOAD_USERGROUPS_REQUEST */]:
      case types["_125" /* CORE_LOAD_LIST_USERGROUPS_REQUEST */]:
        return usergroup_reducer_initialState;
      case types["_192" /* CORE_LOAD_USERGROUPS_SUCCESS */]:
      case types["_126" /* CORE_LOAD_LIST_USERGROUPS_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  },
  usergroup: function usergroup() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : usergroup_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_194" /* CORE_LOAD_USERGROUP_REQUEST */]:
        return {};
      case types["_195" /* CORE_LOAD_USERGROUP_SUCCESS */]:
        if (action.payload) return action.payload;else return {};
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/action/reducer.js


var action_reducer_initialState = [];
/* harmony default export */ var action_reducer = ({
  actions: function actions() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : action_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_62" /* CORE_LOAD_ACTIONS_REQUEST */]:
        return action_reducer_initialState;
      case types["_63" /* CORE_LOAD_ACTIONS_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/settings/fbs/reducer.js


var fbs_reducer_initialState = [];
/* harmony default export */ var fbs_reducer = ({
  fbs: function fbs() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fbs_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_77" /* CORE_LOAD_ALLFBS_REQUEST */]:
        return fbs_reducer_initialState;
      case types["_78" /* CORE_LOAD_ALLFBS_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },

  fbsInfo: function fbsInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fbs_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_116" /* CORE_LOAD_FBSINFO_REQUEST */]:
        return {};
      case types["_117" /* CORE_LOAD_FBSINFO_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },

  fbCategory: function fbCategory() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fbs_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_89" /* CORE_LOAD_ALL_CATEGORY_REQUEST */]:
        return fbs_reducer_initialState;

      case types["_90" /* CORE_LOAD_ALL_CATEGORY_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/settings/location/reducer.js


var location_reducer_initialState = [];
/* harmony default export */ var location_reducer = ({
  coreLocations: function coreLocations() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_131" /* CORE_LOAD_LOCATIONS_REQUEST */]:
        return location_reducer_initialState;
      case types["_132" /* CORE_LOAD_LOCATIONS_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/location/building/reducer.js


var building_reducer_initialState = [];
/* harmony default export */ var building_reducer = ({
  building: function building() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : building_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_71" /* CORE_LOAD_ALLBUILDING_REQUEST */]:
        return building_reducer_initialState;

      case types["_72" /* CORE_LOAD_ALLBUILDING_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  buildingInfo: function buildingInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : building_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_104" /* CORE_LOAD_BUILDINGINFO_REQUEST */]:
        return building_reducer_initialState;

      case types["_105" /* CORE_LOAD_BUILDINGINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/location/floor/reducer.js


var floor_reducer_initialState = [];
/* harmony default export */ var floor_reducer = ({
  floor: function floor() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : floor_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_80" /* CORE_LOAD_ALLFLOOR_REQUEST */]:
        return floor_reducer_initialState;

      case types["_81" /* CORE_LOAD_ALLFLOOR_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  floorInfo: function floorInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : floor_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_119" /* CORE_LOAD_FLOORINFO_REQUEST */]:
        return floor_reducer_initialState;
      case types["_120" /* CORE_LOAD_FLOORINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/location/zone/reducer.js


var zone_reducer_initialState = [];
/* harmony default export */ var zone_reducer = ({
  zone: function zone() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : zone_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_86" /* CORE_LOAD_ALLZONE_REQUEST */]:
        return zone_reducer_initialState;

      case types["_87" /* CORE_LOAD_ALLZONE_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  zoneInfo: function zoneInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : zone_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_215" /* CORE_LOAD_ZONEINFO_REQUEST */]:
        return {};
      case types["_216" /* CORE_LOAD_ZONEINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/background/reducer.js


var background_reducer_initialState = [];
/* harmony default export */ var background_reducer = ({
  background: function background() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : background_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_68" /* CORE_LOAD_ALLBACKGROUND_REQUEST */]:
        return background_reducer_initialState;

      case types["_69" /* CORE_LOAD_ALLBACKGROUND_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  backgroundInfo: function backgroundInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_101" /* CORE_LOAD_BACKGROUNDINFO_REQUEST */]:
        return {};

      case types["_102" /* CORE_LOAD_BACKGROUNDINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/fbCategory/reducer.js


var fbCategory_reducer_initialState = [];
/* harmony default export */ var fbCategory_reducer = ({
  fbCategoryInfo: function fbCategoryInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fbCategory_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_42" /* CORE_GET_CATEGORY_INFO_REQUEST */]:
        return {};

      case types["_43" /* CORE_GET_CATEGORY_INFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/iot/reducer.js


var iot_reducer_initialState = [];
/* harmony default export */ var iot_reducer = ({

  iots: function iots() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iot_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_122" /* CORE_LOAD_IOT_REQUEST */]:
        return [];
      case types["_123" /* CORE_LOAD_IOT_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },

  iot: function iot() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iot_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_51" /* CORE_GET_IOT_INFO_REQUEST */]:
        return {};

      case types["_52" /* CORE_GET_IOT_INFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }

});
// CONCATENATED MODULE: ./src/features/hotseat/reducer.js


var hotseat_reducer_initialState = [];
/* harmony default export */ var hotseat_reducer = ({
  allSeat: function allSeat() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hotseat_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_83" /* CORE_LOAD_ALLSEAT_REQUEST */]:
        return hotseat_reducer_initialState;

      case types["_84" /* CORE_LOAD_ALLSEAT_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  seatInfo: function seatInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_170" /* CORE_LOAD_SEATINFO_REQUEST */]:
        return {};

      case types["_171" /* CORE_LOAD_SEATINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  allDisableSeat: function allDisableSeat() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hotseat_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_74" /* CORE_LOAD_ALLDISABLESEAT_REQUEST */]:
        return hotseat_reducer_initialState;

      case types["_75" /* CORE_LOAD_ALLDISABLESEAT_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  disableSeatInfo: function disableSeatInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_110" /* CORE_LOAD_DISABLESEATINFO_REQUEST */]:
        return {};

      case types["_111" /* CORE_LOAD_DISABLESEATINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers.js






// import roomReducer from 'Features/settings/room/reducer'

// import userReducer from 'Features/settings/user/reducer'




















/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
    form: redux_form_es["c" /* reducer */],
    notifications: Object(reapop_lib["reducer"])(),
    auth: reducer,
    ui: ui_reducer,
    integration: integration_reducer.initialState,
    ini: integration_reducer.ini,
    integrationInfo: integration_reducer.integrationInfo,
    roomsO365: rooms_reducer.roomsO365,
    roomsCore: rooms_reducer.roomsCore,
    roomsSubscribe: rooms_reducer.roomsSubscribe,
    roomCore: rooms_reducer.roomCore,
    // rooms: roomReducer.rooms,
    // locations: roomReducer.locations,
    // coreRoom: roomReducer.coreRoom,
    // users : userReducer.users,
    // user : userReducer.user,
    allRoomReport: report_reducer.coreRoom,
    roomReport: report_reducer.roomReport,
    users: user_reducer.users,
    usersO365: user_reducer.usersO365,
    usersAD: user_reducer.usersAD,
    user: user_reducer.user,
    setting: setting_reducer.setting,
    statusSum: report_reducer.statusSum,
    userReport: report_reducer.userReport,
    roomReports: report_reducer.roomReports,
    userSum: report_reducer.userSum,
    roomSum: report_reducer.roomSum,
    amenity: amenity_reducer.amenity,
    amenityInfo: amenity_reducer.amenityInfo,
    fbs: fbs_reducer.fbs,
    fbsInfo: fbs_reducer.fbsInfo,
    fbCategory: fbs_reducer.fbCategory,
    profileList: profile_reducer.profileList,
    profileInfo: profile_reducer.profileInfo,
    usergroups: usergroup_reducer.usergroups,
    usergroup: usergroup_reducer.usergroup,
    actions: action_reducer.actions,
    userStatus: report_reducer.userStatus,
    userSummary: report_reducer.userSummary,
    // roomSummary : reportReducer.roomSummary,
    roomTemp: report_reducer.roomTemp,
    topRoom: report_reducer.topRoom,
    topUser: report_reducer.topUser,
    roomDetail: report_reducer.roomDetail,
    roomsStatus: report_reducer.roomsStatus,
    term: term_reducer.term,
    faq: faq_reducer.faq,
    contactus: contact_reducer.contactus,
    coreLocations: location_reducer.coreLocations,
    building: building_reducer.building,
    buildingInfo: building_reducer.buildingInfo,
    floor: floor_reducer.floor,
    floorinfo: floor_reducer.floorInfo,
    zone: zone_reducer.zone,
    zoneInfo: zone_reducer.zoneInfo,
    background: background_reducer.background,
    backgroundInfo: background_reducer.backgroundInfo,
    fbCategoryInfo: fbCategory_reducer.fbCategoryInfo,
    AD: setting_reducer.AD,
    timezone: setting_reducer.timezone,
    iots: iot_reducer.iots,
    iot: iot_reducer.iot,
    allSeat: hotseat_reducer.allSeat,
    seatInfo: hotseat_reducer.seatInfo,
    allDisableSeat: hotseat_reducer.allDisableSeat,
    disableSeatInfo: hotseat_reducer.disableSeatInfo
}));
// CONCATENATED MODULE: ./src/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [src_middlewares["c" /* checkToken */], src_middlewares["d" /* setToken */], src_middlewares["b" /* api */], lib_default.a];

    var store = Object(es["d" /* createStore */])(reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ }),

/***/ 533:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 576:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/lib/api.js
var api = __webpack_require__(485);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(526);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./node_modules/jsonwebtoken/index.js
var jsonwebtoken = __webpack_require__(527);
var jsonwebtoken_default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken);

// CONCATENATED MODULE: ./src/lib/auth.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// export function setToken(token) {
//     localStorage.setItem('access-token', token)
// }

// export function getToken() {
//     return localStorage.getItem('access-token')
// }

// export function clearToken() {
//     localStorage.removeItem('access-token')
// }




var BSRS_ACCESS_TOKEN = 'bsrs_access_token';
var ACCESS_TOKEN = 'access_token';
var EXPIRES_ON = 'expires_on';
var REFRESH_TOKEN = 'refresh_token';
var SERVICE_TOKEN = 'service_token';
var ROOM = 'room';
var API_URL = 'api_server_url';
var CLIENT_ID = 'client_id';
var SERVICE_TOKEN_EXPIRES = 'service_token_expires_on';
var IS_INTEGRATION = 'isIntegration';
var USER_ID = 'id';
var LIMIT_USERS = 'limitUser';
var FIRST_NAME = 'firstName';
var EMAIL = 'email';
var IS_USER_AD = 'isUserActiveDirectory';
var SYSTEM = 'system';

function getCookie(key) {
    return js_cookie_default.a.get(key);
}

function setCookie(key, value) {
    js_cookie_default.a.set(key, value);
}

function removeCookie(key) {
    js_cookie_default.a.remove(key);
}

function getAccessToken() {
    return getCookie(ACCESS_TOKEN);
}

function getRoom() {
    return getCookie(ROOM);
}

function getService() {
    return getCookie({ CLIENT_ID: CLIENT_ID, API_URL: API_URL });
}

function getAllToken() {
    if (!getCookie(BSRS_ACCESS_TOKEN)) return {};
    return {
        access_token: getCookie(ACCESS_TOKEN),
        expires_on: getCookie(EXPIRES_ON),
        refresh_token: getCookie(REFRESH_TOKEN)
    };
}

function setToken(_ref) {
    var access_token = _ref.access_token,
        expires_on = _ref.expires_on,
        refresh_token = _ref.refresh_token;

    setCookie(ACCESS_TOKEN, access_token);
    setCookie(EXPIRES_ON, expires_on);
    setCookie(REFRESH_TOKEN, refresh_token);
}

function clearToken() {
    removeCookie(ACCESS_TOKEN);
    removeCookie(EXPIRES_ON);
    removeCookie(REFRESH_TOKEN);
    removeCookie(SERVICE_TOKEN);
    removeCookie(SERVICE_TOKEN_EXPIRES);
    removeCookie(ROOM);
    removeCookie(USER_ID);
    removeCookie(IS_INTEGRATION);
}

function getServiceToken() {
    if (!getCookie(BSRS_ACCESS_TOKEN)) return {};
    return {
        service_token: getCookie(SERVICE_TOKEN),
        service_expires_on: getCookie(SERVICE_TOKEN_EXPIRES),
        user_id: getCookie(USER_ID),
        bsrsToken: getCookie(BSRS_ACCESS_TOKEN),
        isIntegration: getCookie(IS_INTEGRATION)
    };
}

function getIsUserActiveDirectory() {
    return getCookie(IS_USER_AD);
}

function setServiceToken(_ref2) {
    var token = _ref2.token,
        expires_on = _ref2.expires_on;

    if ((typeof token === 'undefined' ? 'undefined' : _typeof(token)) !== undefined) setCookie(SERVICE_TOKEN, token);
    if ((typeof expires_on === 'undefined' ? 'undefined' : _typeof(expires_on)) !== undefined) setCookie(SERVICE_TOKEN_EXPIRES, expires_on);
}

function getUserInfo(access_token) {
    if (!access_token) return {};

    var _jwt$decode = jsonwebtoken_default.a.decode(access_token),
        iat = _jwt$decode.iat,
        exp = _jwt$decode.exp,
        appid = _jwt$decode.appid,
        name = _jwt$decode.name,
        email = _jwt$decode.unique_name;

    return {
        iat: iat,
        exp: exp,
        appid: appid,
        name: name,
        email: email
    };
}

function getBSRSToken() {
    return getCookie(BSRS_ACCESS_TOKEN);
}

function setBSRSToken(bsrsToken) {
    var isIntegration = bsrsToken.isIntegration,
        token = bsrsToken.token,
        id = bsrsToken.id,
        company = bsrsToken.company,
        firstName = bsrsToken.firstName,
        email = bsrsToken.email,
        isUserActiveDirectory = bsrsToken.isUserActiveDirectory,
        system_key = bsrsToken.system_key;

    var limitUser = 0;
    if (company) limitUser = company.limitUser;
    setCookie(BSRS_ACCESS_TOKEN, token);
    // setCookie(SERVICE_TOKEN, access_token)
    // setCookie(SERVICE_TOKEN_EXPIRES, expires_on)
    setCookie(IS_INTEGRATION, isIntegration);
    setCookie(USER_ID, id);
    setCookie(LIMIT_USERS, limitUser);
    setCookie(FIRST_NAME, firstName);
    setCookie(EMAIL, email);
    setCookie(IS_USER_AD, isUserActiveDirectory);
    setCookie(SYSTEM, system_key);
}

function getLimitUser() {
    return getCookie(LIMIT_USERS);
}

function getSystem() {
    return getCookie(SYSTEM);
}

function getUserFirstName() {
    return getCookie(FIRST_NAME);
}

function setRoomToken(room, client_id, api_server_url) {
    setCookie(ROOM, room);
    setCookie(CLIENT_ID, client_id);
    setCookie(API_URL, api_server_url);
}

function clearBSRSToken() {
    removeCookie(BSRS_ACCESS_TOKEN);
    removeCookie(SERVICE_TOKEN);
    removeCookie(SERVICE_TOKEN_EXPIRES);
    removeCookie(USER_ID);
    removeCookie(IS_INTEGRATION);
    removeCookie(LIMIT_USERS);
    removeCookie(FIRST_NAME);
    removeCookie(EMAIL);
    removeCookie(IS_USER_AD);
    removeCookie(SYSTEM);
}

function getResultPerPage() {
    return 10;
}
// CONCATENATED MODULE: ./src/lib/setting.js
var timeZone = 'Asia/Bangkok';
var timeFormat = 'YYYY-MM-DDTHH:mm:ss';
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(24);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 30 modules
var react_router_dom_es = __webpack_require__(71);

// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(72);

// EXTERNAL MODULE: ./src/features/auth/selectors.js
var selectors = __webpack_require__(119);

// CONCATENATED MODULE: ./src/lib/withAuthCheck.js






var withAuthCheck_RedirectToLogin = function RedirectToLogin() {
  return react_default.a.createElement(react_router_dom_es["c" /* Redirect */], { to: '/login' });
};
var withAuthCheck_withAuthCheck = function withAuthCheck(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, props);
  };
};

/* harmony default export */ var lib_withAuthCheck = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withAuthCheck'), Object(es["connect"])(function (state) {
    return { isLoggedIn: Object(selectors["a" /* getIsLoggedIn */])(state) };
  }), Object(Recompose["a" /* branch */])(function (_ref) {
    var isLoggedIn = _ref.isLoggedIn;
    return isLoggedIn;
  }, withAuthCheck_withAuthCheck, Object(Recompose["d" /* renderComponent */])(withAuthCheck_RedirectToLogin)))(WrappedComponent);
});
// CONCATENATED MODULE: ./src/lib/withAuthCheckO365.js






var withAuthCheckO365_RedirectToLogin = function RedirectToLogin() {
  return react_default.a.createElement(react_router_dom_es["c" /* Redirect */], { to: '/logino365' });
};
var withAuthCheckO365_withAuthCheckO365 = function withAuthCheckO365(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, props);
  };
};

/* harmony default export */ var lib_withAuthCheckO365 = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withAuthCheckO365'), Object(es["connect"])(function (state) {
    return {
      isLoggedInO365: Object(selectors["b" /* getIsLoggedInO365 */])(state)
    };
  }), Object(Recompose["a" /* branch */])(function (_ref) {
    var isLoggedInO365 = _ref.isLoggedInO365;
    return isLoggedInO365;
  }, withAuthCheckO365_withAuthCheckO365, Object(Recompose["d" /* renderComponent */])(withAuthCheckO365_RedirectToLogin)))(WrappedComponent);
});
// CONCATENATED MODULE: ./src/lib/withO365UserInfo.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var withO365UserInfo_withO365UserInfo = function withO365UserInfo(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, _extends({}, props, { O365UserInfo: props.userInfo }));
  };
};

/* harmony default export */ var lib_withO365UserInfo = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withO365UserInfo'), Object(es["connect"])(function (state) {
    return {
      userInfo: Object(selectors["c" /* getUserInfo */])(state)
    };
  }), withO365UserInfo_withO365UserInfo)(WrappedComponent);
});
// CONCATENATED MODULE: ./src/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return api["a" /* CORE_API_ENDPOINT */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return api["c" /* O365_API_ENDPOINT */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api["b" /* NOTI_API_ENDPOINT */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return getCookie; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "t", function() { return setCookie; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "r", function() { return removeCookie; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return getAccessToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return getRoom; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return getService; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return getAllToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "w", function() { return setToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return clearToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return getServiceToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return getIsUserActiveDirectory; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "v", function() { return setServiceToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return getUserInfo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return getBSRSToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "s", function() { return setBSRSToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return getLimitUser; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return getSystem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return getUserFirstName; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "u", function() { return setRoomToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return clearBSRSToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return getResultPerPage; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeZone; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "x", function() { return timeFormat; });
/* unused concated harmony import withAuthCheck */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lib_withAuthCheck; });
/* unused concated harmony import withAuthCheckO365 */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lib_withAuthCheckO365; });
/* unused concated harmony import withO365UserInfo */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lib_withO365UserInfo; });







/***/ })

},[495]);


// WEBPACK FOOTER //
// app.d241361806f3b8e12ad0.js